import {
  saveApplicationToLife70,
  updateApplicationToLife70,
  validateAppAgainstAUE70,
  addComment,
  getWorkItem,
  getAssignedWorkItem,
  lockWorkItem,
  updateWorkItem,
  updatePolicyRecord,
  getTakeover,
  createTakeover,
  updateTakeover,
  getSaldOccClassInfo,
  getWriteToApplicantStatus,
  getWorkItemChildren,
  createWorkItem,
  createChildrenRelationship,
} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as A from 'ApplicationEntry/ducks/application';
import * as M from 'ApplicationEntry/ducks/messages';
import * as PR from 'ApplicationEntry/ducks/policyRecord';
import {addWorkItem} from 'ApplicationEntry/ducks/workQueue';
import {matchApplicantDemographicsByType} from 'ApplicationEntry/models/ApplicantDemographics';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {matchBillingAgentByType} from 'ApplicationEntry/models/BillingAgent';
import {matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import {InvalidModalApplication, ValidModalApplication} from 'ApplicationEntry/models/ModalApplication';
import {PlanCodeItem} from 'ApplicationEntry/models/PlanCodes';
import {PolicyNumber} from 'ApplicationEntry/models/PolicyNumber';
import {Premium} from 'ApplicationEntry/models/Premium';
import {UpdateWork, updateWork} from 'ApplicationEntry/models/AWDStatus/UpdateWork';
import {
  Accident,
  handleRidersInQuality,
  matchAccidentByType,
} from 'ApplicationEntry/models/ProductsRiders/Accident/Accident';
import {GroupAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/GroupAccident';
import {GroupAccidentNewYork} from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/GroupAccidentNewYork';
import {matchCancerByType} from 'ApplicationEntry/models/ProductsRiders/Cancer/Cancer';
import {matchCriticalIllnessByType} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/CriticalIllness';
import {matchDisabilityByType} from 'ApplicationEntry/models/ProductsRiders/Disability/Disability';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';
import {matchHeartStrokeByType} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/HeartStroke';
import {matchIWLByType} from 'ApplicationEntry/models/ProductsRiders/IWL/IWL';
import * as RI from 'ApplicationEntry/models/ProductsRiders/RiderInformation';
import {matchShopByType} from 'ApplicationEntry/models/ProductsRiders/Shop/Shop';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded, ServerError} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import * as I from 'immutable';
import {all, put, takeEvery} from 'redux-saga/effects';
import DateUtility from 'Shared/utilities/DateUtility';
import {createSnackbar} from 'Core/ducks/snackbar';
import {WorkInstanceFieldValue} from 'ApplicationEntry/models/WorkInstanceFieldValue';
import {InvalidApplication, matchApplicationByType, ValidApplication} from 'ApplicationEntry/models/Application';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {matchULByType} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/UniversalLife';
import {matchGLTERMByType} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GLTERM';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import {GroupShop} from 'ApplicationEntry/models/ProductsRiders/Shop/GroupShop';
import {ValidGroupApplicantDemographics} from 'ApplicationEntry/models/GroupApplicantDemographics';
import {GroupDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/GroupDisability';
import generateRandomNumber from 'Shared/utilities/UniqueRandomNumberGenerator';
import { date } from 'fp-ts';
import { cons } from 'fp-ts/lib/Array';

enum OperationType {
  Save,
  Update,
  Validate,
}

export type Application = {
  caseInformation: {
    agents: Agent[]; // X
    billingAccountNumber: string; // X
    billingDraftDay: string; // X
    billingInkAuthorization: boolean; // X
    billingMode: string; // X
    billingTransitNumber: string; // X
    caseName: string; // X
    caseNumber: string; // X
    clients: Client[]; // X
    dateOfFirstDeduction: string; // X
    dateSigned: string; // X
    directBill: boolean; // X
    floridaLicenseIncluded: boolean; // X
    numberOfPays: number; // X
    payorNumber: string; // X
    payroll: boolean; // X
    piIsPayor: boolean; // X
    policies: Policy[]; // X
    processCase: boolean;
    recordType: string; // X
    replacement: boolean; // X
    requestedIssueDate: string; // X
    situs: string; // X
    totalPremium: number; // X
    achIndicator: boolean | '';
    achTransitNumber: string;
    achAccountNumber: string;
    achAccountType: string;
    achPayerName: string;
    achDraftDay: string;
    achAuthorizationDate: string;
    pac: boolean | '';
  };
};

export type Address = {
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  state: string;
  zipCode: string;
};

export type Client = {
  address: Address;
  age: number;
  beneficiary: boolean;
  beneficiaryPercent: number;
  beneficiarySignatureDate: string;
  beneficiaryPersonType: string;
  dateOfBirth: string;
  dependent: boolean;
  employee: boolean;
  employeeModel: {
    dateOfHire: string;
    employeeNumber: string;
    employer: string;
    occupation: string;
  };
  firstName: string;
  gender: string;
  lastName: string;
  middleName: string;
  payor: boolean;
  policyOwner: boolean;
  proposedInsured: boolean;
  relationshipToPI: string;
  relationshipToEmployee: string;
  ssn: string;
  height: string;
  weight: string;
  occupation: string;
  occupationCode: string;
  emailAddress: string;
  workPhone: string;
  ownerSigned: boolean;
  useForMail: boolean;
  questionnaire: Question[];
  crossReference: number;
  occSmokerCode: string;
  fullTimeStudent: boolean | '';
  accidentDependent: boolean;
  cancerDependent: boolean;
  shopDependent: boolean;
  personCode: string;
  signatureDate: string;
};

export type Question = {
  questionNumber: number;
  yesNo: boolean;
  remark: string;
  occurrencePersonName: string;
  occurrenceMedicalContact: string;
  tobaccoUse: boolean;
  questionNumberText: string;
};

export type Agent = {
  ahlAgentCode: string;
  licenseState: string;
  percentage: number;
  agentSigned: boolean;
  name: string;
};

export type Form = {
  documentShortName?: string;
  fipscoDocumentName?: string;
  documentLongName?: string;
  documentName?: string;
  value?: string;
};

export type CashWithApplication = {
  amount: number;
  calculatedAmount: number;
  transactionDate: string;
};

export type Policy = {
  awdWorkId: string; // Does not persist
  baseUnits: number; // X
  benefitPeriod: number; // X
  cashWithApplication: CashWithApplication; // X
  companyCode: number; // X
  coverageLevel: string; // X
  coverageTier: number; // Does not persist
  deathBenefit: number; // X
  disabilityOccupationalClass: string; // X
  eeiIndicator: string; // X
  eliminationPeriod: string; // X
  faceAmount: number; // X
  forcedPremium: number; // X
  form: Form; // X
  groupAnswer: boolean; // X
  hsa: boolean; // X
  issueType: string; // X
  monthlyBenefit: number; // X
  monthlySalary: number; // X
  occupationalClass: string; // X
  originalPolicyNumber: string; // X
  perDeduction: number; // X
  planCode: string; // X
  planOption: string; // X
  policyNumber: string; // X
  policyUnits: number; // X
  productCode: string; // X
  productFamily: string; // X
  productGroup: string; // X
  replacementPremium: number; // X
  riders: Rider[]; // X
  section125: boolean; // X
  takeover: boolean; // X
  mentalNervousExclusion: string;
};

export type Rider = {
  code: string;
  units: number;
  planLevel?: string;
  apdir1?: boolean;
};

export type AUEResponse = {
  validations: ValidatedPolicy[];
  messages: object[];
};

export type ValidatedPolicy = {
  validationMessages: object[];
};

const getTotalPremium = (
  premium: Premium,
  billingMode: string,
  overrideAnnualPremium: boolean,
  annualValue: number
) => {
  if (overrideAnnualPremium) {
    return Number(annualValue);
  } else {
    if (billingMode === 'Monthly') {
      return Number(premium.monthly.value);
    } else if (billingMode === 'Weekly') {
      return Number(premium.weekly.value);
    } else if (billingMode === 'Bi-Weekly') {
      return Number(premium.biWeekly.value);
    } else if (billingMode === 'Quarterly') {
      return Number(premium.quarterly.value);
    } else if (billingMode === '28day') {
      return Number(premium.twentyEightDays.value);
    } else if (billingMode === 'SemiMonthly') {
      return Number(premium.semiMonthly.value);
    } else if (billingMode === 'SemiAnnual') {
      return Number(premium.semiAnnual.value);
    } else if (billingMode === 'Ninthly') {
      return Number(premium.ninthly.value);
    } else if (billingMode === 'Tenthly') {
      return Number(premium.tenthly.value);
    } else if (billingMode === 'Thirteenthly') {
      return Number(premium.thirteenthly.value);
    } else {
      return 0;
    }
  }
};

const groupBy = (arr: any[], key: string | number) => {
  const initialValue = {};
  return arr.reduce((acc, cval) => {
    const myAttribute = cval[key];
    acc[myAttribute] = [...(acc[myAttribute] || []), cval];
    return acc;
  }, initialValue);
};

function fromEntries<T>(entries: any[]): T {
  return entries.reduce((acc: any, [key, value]: any) => ({...acc, [key]: value}), <T>{});
}

const ordinaryProductForcedPremiumValue = (premium: Premium) => {
  let forcedPrem = 0;

  if (premium.billMode.value !== undefined) {
    switch (premium.billMode.value.toUpperCase()) {
      case 'BI-WEEKLY':
        forcedPrem = Number(premium.biWeekly.value);
        break;
      case 'MONTHLY':
        forcedPrem = Number(premium.monthly.value);
        break;
      case 'WEEKLY':
        forcedPrem = Number(premium.weekly.value);
        break;
      case 'NINTHLY':
        forcedPrem = Number(premium.ninthly.value);
        break;
      case 'TENTHLY':
        forcedPrem = Number(premium.tenthly.value);
        break;
      case 'THIRTEENTHLY':
        forcedPrem = Number(premium.thirteenthly.value);
        break;
      case 'QUARTERLY':
        forcedPrem = Number(premium.quarterly.value);
        break;
      case 'SEMIMONTHLY':
        forcedPrem = Number(premium.semiMonthly.value);
        break;
      case 'SEMIANNUAL':
        forcedPrem = Number(premium.semiAnnual.value);
        break;
      case '28DAY':
        forcedPrem = Number(premium.twentyEightDays.value);
        break;
    }
  }

  return forcedPrem;
};

const groupProductForcedPremiumValue = (premium: Premium) => {
  let forcedPrem = 0;

  if (premium.billMode.value !== undefined) {
    switch (premium.billMode.value.toUpperCase()) {
      case 'MONTHLY':
        forcedPrem = Number(premium.monthly.value);
        break;
      case 'WEEKLY':
        forcedPrem = Number(premium.weekly.value);
    }
  }

  return forcedPrem;
};

const handleAccidentRiders = (accidentObject: Accident) => {
  const ridersList: Rider[] = [];

  const riderCodes = matchAccidentByType({
    Ordinary: ordinaryApp => ordinaryApp.riderInformation.codes,
    Group: groupApp => groupApp.riderCodeList,
    NewYork: newYorkApp => newYorkApp.riderInformation.codes,
  })(accidentObject);

  const riderAmounts = matchAccidentByType({
    Ordinary: ordinaryApp => ordinaryApp.riderInformation.amounts,
    Group: groupApp => groupApp.riderAmounts,
    NewYork: newYorkApp => newYorkApp.riderInformation.amounts,
  })(accidentObject);

  riderCodes.forEach((riderItem, riderIndex) => {
    const riders = {} as Rider;

    if (riderItem !== undefined) {
      riders.code = riderItem;
      riders.units = Number(riderAmounts.get(riderIndex));

      ridersList.push(riders);
    }
  });

  return ridersList;
};

const getPolicyNumber = (policyNumber: PolicyNumber, mode: string) => {
  let policyNo: string = '';
  if (mode === ApplicationModeType.Quality) {
    policyNo = policyNumber.key === 'UserAssignedPolicyNumber' ? policyNumber.value : '';
    if (policyNo.length === 10) {
      policyNo = policyNo.substr(2, 7);
    }
  } else if (mode === ApplicationModeType.Entry) {
    policyNo =
      policyNumber.key === 'Loaded' ? policyNumber.Data : policyNumber.key === 'Reserved' ? policyNumber.value : '';
  }
  return policyNo;
};

const getRidersInQuality = (planCodes: PlanCodeItem[], faceAmount?: number) => {
  const ridersList: Rider[] = [];
  planCodes.forEach((planCode, index) => {
    const riders = {} as Rider;
    if (index !== 0) {
      riders.code = planCode.tracInputL70;
      riders.planLevel = planCode.planLevel;
      if (riders.code === 'IWLST') {
        riders.units = Number(planCode.units) * 1000;
      } else if (riders.code?.endsWith('ADB')) {
        riders.units = Number(planCode.units) * 1000;
      } else if (riders.code === 'GWCST') {
        riders.units = Number(planCode.units) * 1000;
      } else if (riders.code === 'IWLLT') {
        riders.units = ((Number(planCode.units) * 1000) / faceAmount!) * 100;
      } else if (riders.code === 'IWLCI') {
        riders.units = planCode.description.includes('50%') ? 50 : planCode.description.includes('100%') ? 100 : 0;
      } else if (
        riders.code === 'GUOIR' ||
        riders.code === 'GUTIR' ||
        riders.code === 'GULTC' ||
        riders.code === 'GULTCFL' ||
        riders.code === 'GULTCEXT'
      ) {
        riders.units = Number(planCode.units) * 1000;
      } else {
        riders.units = Number(planCode.units);
      }
      ridersList.push(riders);
    }
  });

  return ridersList;
};

const getNameTokens = (clientName: string) => {
  const nameTokens: string[] = [];
  let lastName = '';
  let firstName = '';
  let middleName = '';
  if (clientName.indexOf(',') !== -1) {
    const name: string[] = clientName.split(',');
    if (name.length > 1) {
      //name in correct format LASTNAME,FIRSTNAME MI
      lastName = name[0];

      const remainingName: string[] = name[1].trim().split(new RegExp(/\s+/));
      firstName = remainingName[0];
      if (remainingName.length > 1) {
        //middle initial has been entered
        middleName = remainingName[1];
      }
    }
  }

  nameTokens.push(firstName, middleName, lastName);

  return nameTokens;
};

const isGroupAccident = (application: InvalidApplication | ValidApplication, applicationType: ApplicationType) => {
  if (applicationType === ApplicationType.Group) {
    if (
      application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
      application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
        ProductRiderGroups[ProductsRidersPolicyType.Accident].toLocaleLowerCase()!
    ) {
      return true;
    }
  } else {
    return false;
  }
};

const isGroupCI = (application: InvalidApplication | ValidApplication, applicationType: ApplicationType) => {
  if (applicationType === ApplicationType.Group) {
    if (
      application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
      application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
        ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness].toLocaleLowerCase()!
    ) {
      return true;
    }
  } else {
    return false;
  }
};

const isGroupShop = (application: InvalidApplication | ValidApplication, applicationType: ApplicationType) => {
  if (applicationType === ApplicationType.Group) {
    if (
      application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
      application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
        ProductRiderGroups[ProductsRidersPolicyType.Shop].toLocaleLowerCase()!
    ) {
      return true;
    }
  } else {
    return false;
  }
};

const isGroupDisability = (application: InvalidApplication | ValidApplication, applicationType: ApplicationType) => {
  if (applicationType === ApplicationType.Group) {
    if (
      application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
      application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
        ProductRiderGroups[ProductsRidersPolicyType.Disability].toLocaleLowerCase()!
    ) {
      return true;
    }
  } else {
    return false;
  }
};

const isGLTermProduct = (application: InvalidApplication | ValidApplication) => {
  if (
    application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
    application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
      ProductRiderGroups[ProductsRidersPolicyType.GLTerm].toLocaleLowerCase()!
  ) {
    return true;
  } else {
    return false;
  }
};
const isGroupUniversalLifeProduct = (application: InvalidApplication | ValidApplication) => {
  if (
    application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
    application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
      ProductRiderGroups[ProductsRidersPolicyType.UniversalLife].toLocaleLowerCase()!
  ) {
    return true;
  } else {
    return false;
  }
};

const isGroupWholeLifeProduct = (application: InvalidApplication | ValidApplication) => {
  if (
    application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
    application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
      ProductRiderGroups[ProductsRidersPolicyType.Gwl].toLocaleLowerCase()!
  ) {
    return true;
  } else {
    return false;
  }
};

const isPrimaryInsuredthePayor = (application: InvalidApplication | ValidApplication): boolean => {
  const applicationType = matchCaseDetailsByType({
    Group: () => ApplicationType.Group,
    Ordinary: () => ApplicationType.Ordinary,
    NewYork: () => ApplicationType.NewYork,
  })(application.caseDetails);

  if (
    applicationType === ApplicationType.Group &&
    application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
    application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
      ProductRiderGroups[ProductsRidersPolicyType.GLTerm].toLocaleLowerCase()!
  ) {
    if (!application.ownerInfo.applicantIsOwner) {
      return false;
    } else {
      return true;
    }
  } else if (
    applicationType === ApplicationType.Group &&
    application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
    application.caseDetails.productType.selectedPolicyTypes[0]?.productGroup?.toLocaleLowerCase() ===
      ProductRiderGroups[ProductsRidersPolicyType.UniversalLife].toLocaleLowerCase()!
  ) {
    if (!application.ownerInfo.applicantIsOwner) {
      return false;
    } else {
      return true;
    }
  } else if (application.billingAgent.payor.value !== '') {
    return true;
  } else {
    return false;
  }
};

const getApplicationDetails = (
  modalApplication: ValidModalApplication | InvalidModalApplication,
  operationType: OperationType
) => {
  const {application, mode} = modalApplication;

  let applicantFirstName: string = '';
  let applicantMiddleName: string = '';
  let applicantLastName: string = '';
  let ownerFirstName: string = '';
  let ownerMiddleName: string = '';
  let ownerLastName: string = '';

  if (application.applicantDemographics.name.value !== '') {
    const tokens = getNameTokens(application.applicantDemographics.name.value);
    applicantFirstName = tokens[0];
    applicantMiddleName = tokens[1];
    applicantLastName = tokens[2];
  }

  if (application.ownerInfo.ownerName.value !== '') {
    const tokens = getNameTokens(application.ownerInfo.ownerName.value);
    ownerFirstName = tokens[0];
    ownerMiddleName = tokens[1];
    ownerLastName = tokens[2];
  }

  const agentsList: Agent[] = [];

  application.agentList.agentList.forEach(item => {
    const agents = {} as Agent;

    agents.ahlAgentCode =
      item.agentNumber.key === 'UserAssignedAgentNumber' || item.agentNumber.key === 'AgentNumberError'
        ? item.agentNumber.value
        : '';
    agents.licenseState = application.billingAgent.state.value;
    agents.percentage = item.percent;
    agents.agentSigned = item.signed;
    agents.name = item.agentName.value;

    agentsList.push(agents);
  });

  let {situsState} = application.caseDetails as ValidGroupCaseDetails;

  const applicantHeight = matchApplicantDemographicsByType({
    Ordinary: ordinaryApp => ordinaryApp.height.feet + '' + ordinaryApp.height.inches,
    _: () => null,
  })(application.applicantDemographics);

  const applicantWeight = matchApplicantDemographicsByType({
    Ordinary: ordinaryApp => ordinaryApp.weight,
    _: () => null,
  })(application.applicantDemographics);

  const applicantOccupation = matchApplicantDemographicsByType({
    Ordinary: ordinaryApp =>
      ordinaryApp.occupation.key === 'UserAssignedOccupation' ? ordinaryApp.occupation.description : '',
    _: () => null,
  })(application.applicantDemographics);

  const applicantOccupationCode = matchApplicantDemographicsByType({
    Ordinary: ordinaryApp =>
      ordinaryApp.occupation.key === 'UserAssignedOccupation' ? ordinaryApp.occupation.code : '',
    _: () => null,
  })(application.applicantDemographics);

  const email = matchApplicantDemographicsByType({
    Ordinary: ordinary => ordinary.email,
    Group: group => group.email,
    _: () => null,
  })(application.applicantDemographics);

  const hireDate = matchApplicantDemographicsByType({
    Ordinary: ordinaryApp => ordinaryApp.hireDate,
    Group: groupApp => groupApp.hireDate,
    _: () => null,
  })(application.applicantDemographics);

  const transitNumber = matchBillingAgentByType({
    Ordinary: ordinaryApp => ordinaryApp.transit.value,
    NewYork: newYorkApp => newYorkApp.transit.value,
    _: () => null,
  })(application.billingAgent);

  const draftDay = matchBillingAgentByType({
    Ordinary: ordinaryApp => ordinaryApp.draftDay.value,
    NewYork: newYorkApp => newYorkApp.draftDay.value,
    _: () => null,
  })(application.billingAgent);

  const achDraftDay = matchBillingAgentByType({
    Group: groupApp => groupApp.achDraftDay.value,
    _: () => null,
  })(application.billingAgent);

  const accountNumber = matchBillingAgentByType({
    Ordinary: ordinaryApp => ordinaryApp.account.value,
    NewYork: newYorkApp => newYorkApp.account.value,
    _: () => null,
  })(application.billingAgent);

  const policyLists: Policy[] = [];

  const productGroups =
    application.caseDetails.productType.key === 'LoadedPolicyTypes'
      ? application.caseDetails.productType.selectedPolicyTypes
      : null;

  let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

  let totalOfPremium = 0;

  let numberOfPays = 0;

  if (application.billingAgent.billingMode.value === '') {
    numberOfPays = application.billingModes.billingModes
      .flatMap(m => m.occurrences)
      .find(x => x.name.toUpperCase() === billingCode?.value.toUpperCase())?.frequency!;
  } else {
    numberOfPays = application.billingModes.billingModes
      .flatMap(m => m.occurrences)
      .find(x => x.name.toUpperCase() === application.billingAgent.billingMode.value.toUpperCase())?.frequency!;
  }

  const applicationType = matchCaseDetailsByType({
    Group: () => ApplicationType.Group,
    Ordinary: () => ApplicationType.Ordinary,
    NewYork: () => ApplicationType.NewYork,
  })(application.caseDetails);

  const caseNum = matchCaseDetailsByType({
    Ordinary: () =>
      matchBillingAgentByType({
        Ordinary: ordinaryApp =>
          ordinaryApp.caseNumber.key === 'Loaded'
            ? ordinaryApp.caseNumber.Data
            : ordinaryApp.caseNumber.key === 'UserAssignedCaseNumber'
            ? ordinaryApp.caseNumber.value
            : '',
        _: () => '',
      })(application.billingAgent),
    Group: groupApp =>
      groupApp.caseNumber.key === 'Loaded'
        ? groupApp.caseNumber.Data
        : OperationType.Update && groupApp.caseNumber.key === 'UserAssignedCaseNumber'
        ? groupApp.caseNumber.value
        : '',
    NewYork: () =>
      matchBillingAgentByType({
        NewYork: newYorkApp =>
          newYorkApp.caseNumber.key === 'UserAssignedCaseNumber' ? newYorkApp.caseNumber.value : '',
        _: () => '',
      })(application.billingAgent),
  })(application.caseDetails);

  const caseName = matchCaseDetailsByType({
    Ordinary: () =>
      matchBillingAgentByType({
        Ordinary: ordinaryApp => ordinaryApp.caseName.value,
        _: () => '',
      })(application.billingAgent),
    Group: groupApp => groupApp.caseName.value,
    NewYork: () =>
      matchBillingAgentByType({
        NewYork: newYorkApp => newYorkApp.caseName.value,
        _: () => '',
      })(application.billingAgent),
  })(application.caseDetails);

  let defaultPhone = '';
  let defaultEmail = '';

  let isReplacementPolicy = false;

  let heightWeightQuestionAnswered: boolean = false;

  const clientListObject: Client[] = [];

  if (application.applicantDemographics !== null) {
    const clientObject: Client = {} as Client;
    clientObject.address = {
      streetAddress1: application.applicantDemographics.address.value,
      streetAddress2: application.applicantDemographics.addressLine2.value,
      city: application.applicantDemographics.city.value,
      state: application.applicantDemographics.state.value,
      zipCode: application.applicantDemographics.zip.value,
    };
    clientObject.age = application.applicantDemographics.dateOfBirth
      ? DateUtility.getAgeFromDob(application.applicantDemographics.dateOfBirth)
      : 0;
    clientObject.beneficiary = false;
    clientObject.beneficiaryPercent = 0;
    clientObject.beneficiaryPersonType = '';
    clientObject.beneficiarySignatureDate = '';
    clientObject.dateOfBirth = application.applicantDemographics.dateOfBirth
      ? DateUtility.toIsoDate(application.applicantDemographics.dateOfBirth)
      : '';
    clientObject.dependent = false;
    clientObject.accidentDependent = true;
    clientObject.shopDependent = true;
    clientObject.cancerDependent = true;
    clientObject.crossReference = Math.round(generateRandomNumber(['1000000']) * 100000);
    clientObject.workPhone =
      application.applicantDemographics.phone.phoneNumber === ''
        ? defaultPhone
        : application.applicantDemographics.phone.phoneNumber.replace('-', '');
    clientObject.firstName = applicantFirstName;
    clientObject.middleName = applicantMiddleName;
    clientObject.lastName = applicantLastName;
    clientObject.gender = application.applicantDemographics.sex.toString();
    clientObject.proposedInsured = true;
    clientObject.relationshipToPI = 'SELF';

    if (applicationType === ApplicationType.Group && mode === ApplicationModeType.Quality) {
      if (isGLTermProduct(application) && application.planCodes.replaceProduct) {
        if (!application.ownerInfo.applicantIsOwner) {
          clientObject.relationshipToEmployee = application.glterm.type.value;
        } else {
          clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
        }
      } else if (isGroupUniversalLifeProduct(application) && application.planCodes.replaceProduct) {
        if (!application.ownerInfo.applicantIsOwner) {
          clientObject.relationshipToEmployee = application.universalLife.type.value;
        } else {
          clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
        }
      } else if (isGroupWholeLifeProduct(application) && application.planCodes.replaceProduct) {
        if (!application.ownerInfo.applicantIsOwner) {
          clientObject.relationshipToEmployee = matchIWLByType({
            Group: groupApp => groupApp.coverageLevel.value,
            _: () => '',
          })(application.iwl);
        } else {
          clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
        }
      } else {
        clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
      }
    } else if (
      applicationType === ApplicationType.Group &&
      mode === ApplicationModeType.Entry &&
      isGroupUniversalLifeProduct(application)
    ) {
      if (!application.ownerInfo.applicantIsOwner) {
        clientObject.relationshipToEmployee = application.universalLife.type.value;
      } else {
        clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
      }
    } else if (
      applicationType === ApplicationType.Group &&
      mode === ApplicationModeType.Entry &&
      isGLTermProduct(application)
    ) {
      if (!application.ownerInfo.applicantIsOwner) {
        clientObject.relationshipToEmployee = application.glterm.type.value;
      } else {
        clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
      }
    } else if (
      applicationType === ApplicationType.Group &&
      mode === ApplicationModeType.Entry &&
      isGroupWholeLifeProduct(application)
    ) {
      if (!application.ownerInfo.applicantIsOwner) {
        clientObject.relationshipToEmployee = matchIWLByType({
          Group: groupApp => groupApp.coverageLevel.value,
          _: () => '',
        })(application.iwl);
      } else {
        clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';
      }
    } else {
      clientObject.relationshipToEmployee =
        application.applicantDemographics.type.toString() === 'Ind' ||
        application.applicantDemographics.type.toString() === '' ||
        application.applicantDemographics.type.toString() === null
          ? operationType === OperationType.Validate
            ? 'EMPLOYEE'
            : 'SELF'
          : application.applicantDemographics.type.toString();
    }

    clientObject.policyOwner = application.ownerInfo.applicantIsOwner;
    clientObject.payor =
      applicationType === ApplicationType.Group
        ? true
        : application.applicantDemographics.type.toString() === 'Child' ||
          application.applicantDemographics.type.toString() === 'Spouse'
        ? false
        : true;
    clientObject.ssn = application.applicantDemographics.socialSecurityNumber.value;
    clientObject.employeeModel = {
      dateOfHire: hireDate ? DateUtility.toIsoDate(hireDate) : '',
      employeeNumber: application.applicantDemographics.socialSecurityNumber.value,
      employer: '',
      occupation: '',
    };
    clientObject.employee = application.ownerInfo.applicantIsOwner;
    clientObject.height = applicantHeight === null || applicantHeight.includes('NaN') ? '' : applicantHeight.toString();
    clientObject.weight = applicantWeight === null ? '' : applicantWeight.toString();
    clientObject.occupation = applicantOccupation === null ? '' : applicantOccupation;
    clientObject.occupationCode = applicantOccupationCode === null ? '' : applicantOccupationCode;
    clientObject.emailAddress = email === null || email.address === '' ? defaultEmail : email.address;
    clientObject.ownerSigned = application.ownerInfo.ownerSigned;
    clientObject.useForMail = application.ownerInfo.applicantIsOwner ? application.ownerInfo.isMailingAddress : false;

    if (isGroupAccident(application, applicationType)) {
      const grpAccident = application.accident as GroupAccident;
      clientObject.occSmokerCode =
        grpAccident?.occClass.key == 'Loaded' ? grpAccident.occClass.Data.saldOccClassInfo.originalOccClass : '';
    }

    if (
      applicationType === ApplicationType.Group &&
      productGroups !== null &&
      mode === ApplicationModeType.Quality &&
      !application.planCodes.replaceProduct &&
      application.planCodes.productType.value === 'GVAP6'
    ) {
      const accidentAppDemoGraphics = application.applicantDemographics as ValidGroupApplicantDemographics;
      clientObject.occSmokerCode = accidentAppDemoGraphics.occSmokerCode.value;
    }

    if (isGroupShop(application, applicationType)) {
      const grpShop = application.shop as GroupShop;
      clientObject.occSmokerCode =
        grpShop?.occClass.key == 'Loaded' ? grpShop.occClass.Data.saldOccClassInfo.originalOccClass : '';
    }

    if (
      applicationType === ApplicationType.Group &&
      productGroups !== null &&
      mode === ApplicationModeType.Quality &&
      !application.planCodes.replaceProduct &&
      application.planCodes.productType.value === 'GVSP2'
    ) {
      const shopAppDemoGraphics = application.applicantDemographics as ValidGroupApplicantDemographics;
      clientObject.occSmokerCode = shopAppDemoGraphics.occSmokerCode.value;
    }

    if (isGroupDisability(application, applicationType)) {
      const grpDisability = application.disability as GroupDisability;
      clientObject.occSmokerCode =
        grpDisability?.occClass.key == 'Loaded' ? grpDisability.occClass.Data.saldOccClassInfo.originalOccClass : '';
    }

    if (
      applicationType === ApplicationType.Group &&
      productGroups !== null &&
      mode === ApplicationModeType.Quality &&
      !application.planCodes.replaceProduct &&
      application.planCodes.productType.value === 'GVDIP'
    ) {
      const disabilityAppDemoGraphics = application.applicantDemographics as ValidGroupApplicantDemographics;
      clientObject.occSmokerCode = disabilityAppDemoGraphics.occSmokerCode.value;
    }

    if (applicationType === ApplicationType.Group && isGLTermProduct(application)) {
      if (!application.ownerInfo.applicantIsOwner) {
        clientObject.payor = false;
      } else {
        clientObject.payor = true;
      }
    }
    if (applicationType === ApplicationType.Group && isGroupUniversalLifeProduct(application)) {
      if (!application.ownerInfo.applicantIsOwner) {
        clientObject.payor = false;
      } else {
        clientObject.payor = true;
      }
    }

    if (applicationType === ApplicationType.Group && isGroupWholeLifeProduct(application)) {
      if (!application.ownerInfo.applicantIsOwner) {
        clientObject.payor = false;
      } else {
        clientObject.payor = true;
      }
    }

    if (
      !isGroupAccident(application, applicationType) &&
      !isGroupShop(application, applicationType) &&
      !isGroupDisability(application, applicationType)
    ) {
      clientObject.occSmokerCode = matchApplicantDemographicsByType({
        Group: groupApp => (groupApp.occSmokerCode.value.toString().startsWith("S") ? "Smoker" :  "Non Smoker"),
        Ordinary: ordApp => ordApp.occSmokerCode.value.toString(),
        _: () => '',
      })(application.applicantDemographics);
    }
    clientObject.fullTimeStudent = matchApplicantDemographicsByType({
      Ordinary: ordinaryApp => (ordinaryApp.isFullTimeStudent === '' ? false : ordinaryApp.isFullTimeStudent),
      _: () => false,
    })(application.applicantDemographics);

    if (productGroups !== null && mode !== ApplicationModeType.Quality) {
      productGroups.forEach(item => {
        if (Object.keys(item).length === 0) {
          return;
        }
        switch (item.productGroup!.toUpperCase()) {
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
            clientObject.occSmokerCode = application.criticalIllness.insuredSC.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Iwl]:
            clientObject.occSmokerCode = application.iwl.priInsured.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.UniversalLife]:
            clientObject.occSmokerCode = application.universalLife.priInsured.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.GLTerm]:
            clientObject.occSmokerCode = (application.glterm.priInsured.value.startsWith("S") ? "Smoker" :  "Non Smoker");
            break;
        }
      });
    } else if (
      applicationType === ApplicationType.Ordinary &&
      productGroups !== null &&
      mode === ApplicationModeType.Quality &&
      application.planCodes.replaceProduct
    ) {
      productGroups?.forEach(item => {
        if (Object.keys(item).length === 0) {
          return;
        }
        switch (item.productGroup!.toUpperCase()) {
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
            clientObject.occSmokerCode = application.criticalIllness.insuredSC.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Iwl]:
            clientObject.occSmokerCode = application.iwl.priInsured.value;
            break;
        }
      });
    } else if (
      applicationType === ApplicationType.Group &&
      productGroups !== null &&
      mode === ApplicationModeType.Quality &&
      application.planCodes.replaceProduct
    ) {
      productGroups?.forEach(item => {
        if (Object.keys(item).length === 0) {
          return;
        }
        switch (item.productGroup!.toUpperCase()) {
          case ProductRiderGroups[ProductsRidersPolicyType.GLTerm]:
            clientObject.occSmokerCode = application.glterm.priInsured.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Gwl]:
            clientObject.occSmokerCode = application.iwl.priInsured.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Accident]:
            const accidentAppDemoGraphics = application.applicantDemographics as ValidGroupApplicantDemographics;
            clientObject.occSmokerCode = accidentAppDemoGraphics.occSmokerCode.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Shop]:
            const shopAppDemoGraphics = application.applicantDemographics as ValidGroupApplicantDemographics;
            clientObject.occSmokerCode = shopAppDemoGraphics.occSmokerCode.value;
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
            clientObject.occSmokerCode = application.criticalIllness.insuredSC.value;
            break;
        }
      });
    }

    const question: Question[] = [];

    const questions =
      application.uwQuestions.questionList.key === 'Loaded' ? application.uwQuestions.questionList.Data : '';

    if (questions !== '') {
      questions.forEach((questionnaire, index) => {
        const questionItem = {} as Question;

        if (application.uwQuestions.answers.get(index) !== '') {
          questionItem.questionNumber = Number(questionnaire.questionOrder);
          questionItem.questionNumberText = questionnaire.questionName;
          questionItem.remark = questionnaire.description;
          if (applicationType === ApplicationType.Group && questionItem.remark.toUpperCase() === 'HEIGHTWEIGHT') {
            questionItem.yesNo = application.uwQuestions.answers.get(index) as boolean;

            if (questionItem.yesNo) {
              heightWeightQuestionAnswered = true;
              clientObject.height =
                application.uwQuestions?.height !== undefined
                  ? application.uwQuestions?.height?.feet + '' + application.uwQuestions?.height?.inches
                  : '';
              clientObject.weight =
                application.uwQuestions?.weight !== undefined ? application.uwQuestions?.weight!.toString() : '';
            } else {
              clientObject.height = '';
              clientObject.weight = '';
            }
          }

          questionItem.yesNo = application.uwQuestions.answers.get(index) as boolean;

          question.push(questionItem);
        }
      });
    }

    clientObject.questionnaire = question;

    clientListObject.push(clientObject);
  }

  if (!application.ownerInfo.applicantIsOwner) {
    const clientObject: Client = {} as Client;

    clientObject.address = {
      streetAddress1: application.ownerInfo.address.value,
      streetAddress2: application.ownerInfo.addressLine2.value,
      city: application.ownerInfo.city.value,
      state: application.ownerInfo.state.value,
      zipCode: application.ownerInfo.zip.value,
    };
    clientObject.age = application.ownerInfo.dateOfBirth
      ? DateUtility.getAgeFromDob(application.ownerInfo.dateOfBirth)
      : 0;
    clientObject.beneficiary = false;
    clientObject.beneficiaryPercent = 0;
    clientObject.beneficiaryPersonType = '';
    clientObject.beneficiarySignatureDate = '';
    clientObject.dateOfBirth = application.ownerInfo.dateOfBirth
      ? DateUtility.toIsoDate(application.ownerInfo.dateOfBirth)
      : '';
    clientObject.dependent = false;
    clientObject.workPhone = application.ownerInfo.phone.phoneNumber.replace('-', '');
    clientObject.firstName = ownerFirstName;
    clientObject.middleName = ownerMiddleName;
    clientObject.lastName = ownerLastName;
    clientObject.gender = '';
    clientObject.proposedInsured = false;
    clientObject.relationshipToPI =
      applicationType === ApplicationType.Group
        ? application.planCodes.coverageLevel.value
        : application.applicantDemographics.type.toString() === 'Ind' ||
          application.applicantDemographics.type.toString() === '' ||
          application.applicantDemographics.type.toString() === null
        ? 'SELF'
        : application.applicantDemographics.type.toString();

    clientObject.relationshipToEmployee = operationType === OperationType.Validate ? 'EMPLOYEE' : 'SELF';

    clientObject.policyOwner = true;
    clientObject.crossReference = Math.round(generateRandomNumber(['1000000']) * 100000);
    clientObject.payor =
      applicationType === ApplicationType.Group
        ? true
        : application.applicantDemographics.type.toString() === 'Child' ||
          application.applicantDemographics.type.toString() === 'Spouse'
        ? true
        : false;
    clientObject.ssn = application.ownerInfo.socialSecurityNumber.value;
    clientObject.employeeModel = {
      dateOfHire: '',
      employeeNumber: '',
      employer: '',
      occupation: '',
    };
    clientObject.employee = true;
    clientObject.height = '';
    clientObject.weight = '';
    clientObject.occupation = '';
    clientObject.emailAddress = '';
    clientObject.useForMail = application.ownerInfo.isMailingAddress;
    clientObject.ownerSigned = application.ownerInfo.ownerSigned;

    clientListObject.push(clientObject);
  }

  if (application.dependentLists.dependentList.count() > 0) {
    application.dependentLists.dependentList.forEach(dependent => {
      const dependentObject: Client = {} as Client;

      dependentObject.address = {
        streetAddress1: dependent.address.value,
        streetAddress2: dependent.addressLine2,
        city: dependent.city.value,
        state: dependent.state.value,
        zipCode: dependent.zip.value,
      };
      dependentObject.age = dependent.dob ? DateUtility.getAgeFromDob(dependent.dob) : 0;
      dependentObject.beneficiary = false;
      dependentObject.beneficiaryPercent = 0;
      dependentObject.beneficiaryPersonType = '';
      dependentObject.beneficiarySignatureDate = '';
      const month = dependent.dob ? `${dependent.dob.getMonth() + 1}`.padStart(2, '0') : '';
      const day = dependent.dob ? `${dependent.dob.getDate()}`.padStart(2, '0') : '';

      dependentObject.dateOfBirth = dependent.dob ? dependent.dob.getFullYear() + '-' + month + '-' + day : '';
      dependentObject.dependent = true;
      dependentObject.workPhone = dependent.phone.phoneNumber.replace('-', '');
      dependentObject.firstName = dependent.firstName.value;
      dependentObject.middleName = dependent.middleName.value;
      dependentObject.lastName = dependent.lastName.value;
      dependentObject.gender = dependent.sex.toString();
      dependentObject.proposedInsured = false;
      dependentObject.relationshipToPI =
        dependent.relationship.value.toUpperCase() === 'STEP-CHILD'
          ? 'CHILD'
          : dependent.relationship.value.toUpperCase() === 'DOMESTIC PARTNER'
          ? 'SPOUSE'
          : dependent.relationship.value.toUpperCase() === 'GRANDCHILD'
          ? 'OTHER'
          : dependent.relationship.value.toUpperCase();
      dependentObject.relationshipToEmployee =
        dependent.relationship.value.toUpperCase() === 'STEP-CHILD'
          ? 'CHILD'
          : dependent.relationship.value.toUpperCase() === 'DOMESTIC PARTNER'
          ? 'SPOUSE'
          : dependent.relationship.value.toUpperCase() === 'GRANDCHILD'
          ? 'OTHER'
          : dependent.relationship.value.toUpperCase();
      dependentObject.policyOwner = false;
      dependentObject.payor = false;
      dependentObject.ssn = dependent.socialSecurityNumber.value;
      dependentObject.employeeModel = {
        dateOfHire: '',
        employeeNumber: '',
        employer: '',
        occupation: '',
      };
      dependentObject.employee = false;
      dependentObject.height = '';
      dependentObject.weight = '';
      dependentObject.occupation = '';
      dependentObject.emailAddress = '';
      dependentObject.crossReference = Math.round(generateRandomNumber(['1000000']) * 100000);
      if (isGroupAccident(application, applicationType)) {
        const grpAccident = application.accident as GroupAccident;
        dependentObject.occSmokerCode =
          grpAccident?.occClass.key == 'Loaded' ? grpAccident.occClass.Data.saldOccClassInfo.originalOccClass : '';
      }

      if (
        applicationType === ApplicationType.Group &&
        productGroups !== null &&
        mode === ApplicationModeType.Quality &&
        !application.planCodes.replaceProduct &&
        application.planCodes.productType.value === 'GVAP6'
      ) {
        const accidentAppDemoGraphics = application.applicantDemographics as ValidGroupApplicantDemographics;
        dependentObject.occSmokerCode = accidentAppDemoGraphics.occSmokerCode.value;
      }

      if (
        applicationType === ApplicationType.Group &&
        productGroups !== null &&
        mode === ApplicationModeType.Quality &&
        !application.planCodes.replaceProduct &&
        isGroupCI(application, applicationType)
      ) {
        if (dependent.relationship.value.toUpperCase() === 'SPOUSE') {
          dependentObject.occSmokerCode = dependent.occSmokerCode.value;
        }
      }

      if (isGroupShop(application, applicationType)) {
        const grpShop = application.shop as GroupShop;
        dependentObject.occSmokerCode =
          grpShop?.occClass.key == 'Loaded' ? grpShop.occClass.Data.saldOccClassInfo.originalOccClass : '';
      }

      if (isGroupDisability(application, applicationType)) {
        const grpDisability = application.disability as GroupDisability;
        dependentObject.occSmokerCode =
          grpDisability?.occClass.key == 'Loaded' ? grpDisability.occClass.Data.saldOccClassInfo.originalOccClass : '';
      }

      if (applicationType === ApplicationType.Group) {
        if (mode === ApplicationModeType.Entry) {
          if (
            application.criticalIllness.planType.value.toUpperCase() === 'FAMILY' ||
            application.criticalIllness.planType.value.toUpperCase() === 'INDSPS'
          ) {
            dependentObject.occSmokerCode = application.criticalIllness.spouseSC.value;
          } else if (application.universalLife.spouseInsured.value !== '') {
            dependentObject.occSmokerCode = application.universalLife.spouseInsured.value;
          } else if (application.glterm.spouseInsured.value !== '') {
            dependentObject.occSmokerCode = application.glterm.spouseInsured.value;
          }

          if (application.accident.planType.value.toUpperCase() !== 'IND') {
            dependentObject.accidentDependent = dependent.accidentDependent;
            dependentObject.cancerDependent = dependent.cancerDependent;
            dependentObject.shopDependent = dependent.shopDependent;
          }
          if (application.cancer.planType.value.toUpperCase() !== 'IND') {
            dependentObject.accidentDependent = dependent.accidentDependent;
            dependentObject.cancerDependent = dependent.cancerDependent;
            dependentObject.shopDependent = dependent.shopDependent;
          }
          if (application.shop.planType.value.toUpperCase() !== 'IND') {
            dependentObject.accidentDependent = dependent.accidentDependent;
            dependentObject.cancerDependent = dependent.cancerDependent;
            dependentObject.shopDependent = dependent.shopDependent;
          }
          if (heightWeightQuestionAnswered) {
            if (dependentObject.relationshipToEmployee.toUpperCase() === 'SPOUSE') {
              dependentObject.height =
                application.uwQuestions?.spouseHeight !== undefined
                  ? application.uwQuestions?.spouseHeight?.feet + '' + application.uwQuestions?.spouseHeight?.inches
                  : '';
              dependentObject.weight =
                application.uwQuestions?.spouseWeight !== undefined
                  ? application.uwQuestions?.spouseWeight!.toString()
                  : '';
            }
            if (dependentObject.relationshipToEmployee.toUpperCase() === 'CHILD') {
              dependentObject.height =
                application.uwQuestions?.childHeight !== undefined
                  ? application.uwQuestions?.childHeight?.feet + '' + application.uwQuestions?.childHeight?.inches
                  : '';
              dependentObject.weight =
                application.uwQuestions?.childWeight !== undefined
                  ? application.uwQuestions?.childWeight!.toString()
                  : '';
            }
          }
        } else if (mode === ApplicationModeType.Quality) {
          dependentObject.accidentDependent = true;
          dependentObject.shopDependent = true;
          dependentObject.cancerDependent = true;
        }
      } else if (applicationType === ApplicationType.Ordinary) {
        if (productGroups !== null && mode === ApplicationModeType.Entry) {
          productGroups?.forEach(item => {
            if (Object.keys(item).length === 0) {
              return;
            }
            switch (item.productGroup!.toUpperCase()) {
              case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
                if (
                  application.criticalIllness.planType.value.toUpperCase() === 'FAMILY' ||
                  application.criticalIllness.planType.value.toUpperCase() === 'INDSPS'
                ) {
                  if (dependentObject.relationshipToEmployee === 'SPOUSE') {
                    dependentObject.occSmokerCode = application.criticalIllness.spouseSC.value;
                  }
                }
                break;
            }
          });
        } else if (
          productGroups !== null &&
          mode === ApplicationModeType.Quality &&
          application.planCodes.replaceProduct
        ) {
          dependentObject.accidentDependent = true;
          dependentObject.shopDependent = true;
          dependentObject.cancerDependent = true;
          productGroups?.forEach(item => {
            if (Object.keys(item).length === 0) {
              return;
            }
            switch (item.productGroup!.toUpperCase()) {
              case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]:
                if (
                  application.criticalIllness.planType.value.toUpperCase() === 'FAMILY' ||
                  application.criticalIllness.planType.value.toUpperCase() === 'INDSPS'
                ) {
                  if (dependentObject.relationshipToEmployee === 'SPOUSE') {
                    dependentObject.occSmokerCode = application.criticalIllness.spouseSC.value;
                  }
                }
                break;
            }
          });
        }
      }

      clientListObject.push(dependentObject);
    });
  }

  if (application.primaryBeneficiaryList.primaryBeneficiaryList.count() > 0) {
    application.primaryBeneficiaryList.primaryBeneficiaryList.forEach((primaryBeneficiary, index) => {
      const primaryBeneficiaryObject: Client = {} as Client;

      primaryBeneficiaryObject.address = {
        streetAddress1: primaryBeneficiary.address.value ? primaryBeneficiary.address.value : '',
        streetAddress2: primaryBeneficiary.addressLine2.value ? primaryBeneficiary.addressLine2.value : '',
        city: primaryBeneficiary.city.value ? primaryBeneficiary.city.value : '',
        state: primaryBeneficiary.state.value ? primaryBeneficiary.state.value : '',
        zipCode: primaryBeneficiary.zip.value,
      };
      primaryBeneficiaryObject.age = primaryBeneficiary.dob ? DateUtility.getAgeFromDob(primaryBeneficiary.dob) : 0;
      primaryBeneficiaryObject.beneficiary = true;
      primaryBeneficiaryObject.beneficiaryPercent = primaryBeneficiary.percent;
      primaryBeneficiaryObject.beneficiaryPersonType = 'Primary Beneficiary';
      // primaryBeneficiaryObject.signatureDate = primaryBeneficiary.signatureDate ? DateUtility.toIsoDate(primaryBeneficiary.signatureDate) : '';
      primaryBeneficiaryObject.signatureDate = application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '';
      const month = primaryBeneficiary.dob ? `${primaryBeneficiary.dob.getMonth() + 1}`.padStart(2, '0') : '';
      const day = primaryBeneficiary.dob ? `${primaryBeneficiary.dob.getDate()}`.padStart(2, '0') : '';

      primaryBeneficiaryObject.dateOfBirth = primaryBeneficiary.dob
        ? primaryBeneficiary.dob.getFullYear() + '-' + month + '-' + day
        : '';
      primaryBeneficiaryObject.dependent = false;
      primaryBeneficiaryObject.workPhone = primaryBeneficiary.phone.phoneNumber.replace('-', '');
      primaryBeneficiaryObject.firstName = primaryBeneficiary.firstName.value ? primaryBeneficiary.firstName.value : '';
      primaryBeneficiaryObject.middleName = primaryBeneficiary.middleName.value
        ? primaryBeneficiary.middleName.value
        : '';
      primaryBeneficiaryObject.lastName = primaryBeneficiary.lastName.value ? primaryBeneficiary.lastName.value : '';
      primaryBeneficiaryObject.gender = '';
      primaryBeneficiaryObject.proposedInsured = false;
      primaryBeneficiaryObject.relationshipToPI = OperationType.Validate
        ? primaryBeneficiary?.relationship?.value?.toUpperCase() === 'DAUGHTER' ||
          primaryBeneficiary?.relationship?.value?.toUpperCase() === 'SON' ||
          primaryBeneficiary?.relationship?.value?.toUpperCase() === 'STEPSON' ||
          primaryBeneficiary?.relationship?.value?.toUpperCase() === 'STEPDAUGHTER'
          ? 'CHILD'
          : primaryBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDSON' ||
            primaryBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDDAUGHTER' ||
            primaryBeneficiary?.relationship?.value?.toUpperCase() === 'RECIPROCAL BENEFICIARY' ||
            primaryBeneficiary?.relationship?.value?.toUpperCase() === 'DESIGNATED BENEFICIARY'
          ? 'OTHER'
          : primaryBeneficiary?.relationship?.value?.toUpperCase() === 'DOMESTIC PARTNER'
          ? 'SPOUSE'
          : primaryBeneficiary?.relationship?.value
        : primaryBeneficiary?.relationship?.value;
      primaryBeneficiaryObject.relationshipToEmployee = OperationType.Validate
        ? primaryBeneficiary?.relationship?.value?.toUpperCase() === 'DAUGHTER' ||
          primaryBeneficiary?.relationship?.value?.toUpperCase() === 'SON' ||
          primaryBeneficiary?.relationship?.value?.toUpperCase() === 'STEPSON' ||
          primaryBeneficiary?.relationship?.value?.toUpperCase() === 'STEPDAUGHTER'
          ? 'CHILD'
          : primaryBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDSON' ||
            primaryBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDDAUGHTER' ||
            primaryBeneficiary?.relationship?.value?.toUpperCase() === 'RECIPROCAL BENEFICIARY' ||
            primaryBeneficiary?.relationship?.value?.toUpperCase() === 'DESIGNATED BENEFICIARY'
          ? 'OTHER'
          : primaryBeneficiary?.relationship?.value?.toUpperCase() === 'DOMESTIC PARTNER'
          ? 'SPOUSE'
          : primaryBeneficiary?.relationship?.value?.toUpperCase() === 'SELF'
          ? 'EMPLOYEE'
          : primaryBeneficiary?.relationship?.value
        : primaryBeneficiary?.relationship?.value;
      primaryBeneficiaryObject.policyOwner = false;
      primaryBeneficiaryObject.payor = false;
      primaryBeneficiaryObject.ssn = primaryBeneficiary.socialSecurityNumber.value;
      primaryBeneficiaryObject.employeeModel = {
        dateOfHire: '',
        employeeNumber: '',
        employer: '',
        occupation: '',
      };
      primaryBeneficiaryObject.employee = false;
      primaryBeneficiaryObject.height = '';
      primaryBeneficiaryObject.weight = '';
      primaryBeneficiaryObject.occupation = '';
      primaryBeneficiaryObject.emailAddress = '';
      primaryBeneficiaryObject.occSmokerCode = primaryBeneficiary.occSmokerCode.value;
      primaryBeneficiaryObject.crossReference = Math.round(generateRandomNumber(['1000000']) * 100000);

      let addBeneficiary = true;
      clientListObject.forEach(item => {
        if (
          item?.relationshipToEmployee?.toUpperCase() === 'SPOUSE' &&
          primaryBeneficiaryObject?.relationshipToEmployee?.toUpperCase() === 'SPOUSE' &&
          item.dependent
        ) {
          item.beneficiary = true;
          item.beneficiaryPercent = primaryBeneficiary.percent;
          item.beneficiaryPersonType = 'Primary Beneficiary';
          item.address = {
            streetAddress1: primaryBeneficiary.address.value ? primaryBeneficiary.address.value : '',
            streetAddress2: primaryBeneficiary.addressLine2.value ? primaryBeneficiary.addressLine2.value : '',
            city: primaryBeneficiary.city.value ? primaryBeneficiary.city.value : '',
            state: primaryBeneficiary.state.value ? primaryBeneficiary.state.value : '',
            zipCode: primaryBeneficiary.zip.value,
          };
          item.middleName = primaryBeneficiary.middleName.value ? primaryBeneficiary.middleName.value : '';
          item.workPhone = primaryBeneficiary.phone.phoneNumber.replace('-', '');
          // item.signatureDate = primaryBeneficiary.signatureDate ? DateUtility.toIsoDate(primaryBeneficiary.signatureDate) : '';
          item.signatureDate = application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '';
          addBeneficiary = false;
        } else if (
          item?.relationshipToEmployee?.toUpperCase() === 'CHILD' &&
          primaryBeneficiaryObject?.relationshipToEmployee?.toUpperCase() === 'CHILD' &&
          item.dependent &&
          ((item.ssn && item.ssn === primaryBeneficiaryObject.ssn) ||
            ((item.firstName?.toLowerCase() ===
              primaryBeneficiaryObject.firstName?.toLowerCase() +
                ' ' +
                primaryBeneficiaryObject.middleName?.substring(0, 1).toLowerCase() ||
              item.firstName?.toLowerCase() === primaryBeneficiaryObject.firstName?.toLowerCase()) &&
              item.lastName?.toLowerCase() === primaryBeneficiaryObject.lastName?.toLowerCase() &&
              item.dateOfBirth === primaryBeneficiaryObject.dateOfBirth))
        ) {
          item.beneficiary = true;
          item.beneficiaryPercent = primaryBeneficiary.percent;
          item.beneficiaryPersonType = 'Primary Beneficiary';
          item.address = {
            streetAddress1: primaryBeneficiary.address.value ? primaryBeneficiary.address.value : '',
            streetAddress2: primaryBeneficiary.addressLine2.value ? primaryBeneficiary.addressLine2.value : '',
            city: primaryBeneficiary.city.value ? primaryBeneficiary.city.value : '',
            state: primaryBeneficiary.state.value ? primaryBeneficiary.state.value : '',
            zipCode: primaryBeneficiary.zip.value,
          };
          item.middleName = primaryBeneficiary.middleName.value ? primaryBeneficiary.middleName.value : '';
          item.workPhone = primaryBeneficiary.phone.phoneNumber.replace('-', '');
          // item.signatureDate = primaryBeneficiary.signatureDate ? DateUtility.toIsoDate(primaryBeneficiary.signatureDate) : '';
          item.signatureDate = application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '';
          addBeneficiary = false;
        }
      });

      if (addBeneficiary) {
        if (primaryBeneficiaryObject.dateOfBirth.includes('NaN')) {
          primaryBeneficiaryObject.dateOfBirth = '';
        }
        if (
          primaryBeneficiaryObject.relationshipToEmployee === null &&
          primaryBeneficiaryObject.relationshipToPI === null
        ) {
          primaryBeneficiaryObject.relationshipToEmployee = '';
          primaryBeneficiaryObject.relationshipToPI = '';
        }
        clientListObject.push(primaryBeneficiaryObject);
      }
    });
  }

  if (application.contingentBeneficiaryList.contingentBeneficiaryList.count() > 0) {
    application.contingentBeneficiaryList.contingentBeneficiaryList.forEach(contingentBeneficiary => {
      const contingentBeneficiaryObject: Client = {} as Client;

      contingentBeneficiaryObject.address = {
        streetAddress1: contingentBeneficiary.address.value ? contingentBeneficiary.address.value : '',
        streetAddress2: contingentBeneficiary.addressLine2.value ? contingentBeneficiary.addressLine2.value : '',
        city: contingentBeneficiary.city.value ? contingentBeneficiary.city.value : '',
        state: contingentBeneficiary.state.value ? contingentBeneficiary.state.value : '',
        zipCode: contingentBeneficiary.zip.value,
      };
      contingentBeneficiaryObject.age = contingentBeneficiary.dob
        ? DateUtility.getAgeFromDob(contingentBeneficiary.dob)
        : 0;
      contingentBeneficiaryObject.beneficiary = true;
      contingentBeneficiaryObject.beneficiaryPercent = contingentBeneficiary.percent;
      contingentBeneficiaryObject.beneficiaryPersonType = 'Contingent Beneficiary';
      contingentBeneficiaryObject.beneficiarySignatureDate = '';
      const month = contingentBeneficiary.dob ? `${contingentBeneficiary.dob.getMonth() + 1}`.padStart(2, '0') : '';
      const day = contingentBeneficiary.dob ? `${contingentBeneficiary.dob.getDate()}`.padStart(2, '0') : '';
      // contingentBeneficiaryObject.signatureDate = contingentBeneficiary.signatureDate ? DateUtility.toIsoDate(contingentBeneficiary.signatureDate) : '';
      contingentBeneficiaryObject.signatureDate = application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '';

      contingentBeneficiaryObject.dateOfBirth = contingentBeneficiary.dob
        ? contingentBeneficiary.dob.getFullYear() + '-' + month + '-' + day
        : '';
      contingentBeneficiaryObject.dependent = false;
      contingentBeneficiaryObject.workPhone = contingentBeneficiary.phone.phoneNumber.replace('-', '');
      contingentBeneficiaryObject.firstName = contingentBeneficiary.firstName.value
        ? contingentBeneficiary.firstName.value
        : '';
      contingentBeneficiaryObject.middleName = contingentBeneficiary.middleName.value
        ? contingentBeneficiary.middleName.value
        : '';
      contingentBeneficiaryObject.lastName = contingentBeneficiary.lastName.value
        ? contingentBeneficiary.lastName.value
        : '';
      contingentBeneficiaryObject.gender = '';
      contingentBeneficiaryObject.proposedInsured = false;
      contingentBeneficiaryObject.relationshipToPI = OperationType.Validate
        ? contingentBeneficiary?.relationship?.value?.toUpperCase() === 'DAUGHTER' ||
          contingentBeneficiary?.relationship?.value?.toUpperCase() === 'SON' ||
          contingentBeneficiary?.relationship?.value?.toUpperCase() === 'STEPSON' ||
          contingentBeneficiary?.relationship?.value?.toUpperCase() === 'STEPDAUGHTER'
          ? 'CHILD'
          : contingentBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDSON' ||
            contingentBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDDAUGHTER' ||
            contingentBeneficiary?.relationship?.value?.toUpperCase() === 'RECIPROCAL BENEFICIARY' ||
            contingentBeneficiary?.relationship?.value?.toUpperCase() === 'DESIGNATED BENEFICIARY'
          ? 'OTHER'
          : contingentBeneficiary?.relationship?.value?.toUpperCase() === 'DOMESTIC PARTNER'
          ? 'SPOUSE'
          : contingentBeneficiary?.relationship?.value
        : contingentBeneficiary?.relationship?.value;
      contingentBeneficiaryObject.relationshipToEmployee = OperationType.Validate
        ? contingentBeneficiary?.relationship?.value?.toUpperCase() === 'DAUGHTER' ||
          contingentBeneficiary?.relationship?.value?.toUpperCase() === 'SON' ||
          contingentBeneficiary?.relationship?.value?.toUpperCase() === 'STEPSON' ||
          contingentBeneficiary?.relationship?.value?.toUpperCase() === 'STEPDAUGHTER'
          ? 'CHILD'
          : contingentBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDSON' ||
            contingentBeneficiary?.relationship?.value?.toUpperCase() === 'GRANDDAUGHTER' ||
            contingentBeneficiary?.relationship?.value?.toUpperCase() === 'RECIPROCAL BENEFICIARY' ||
            contingentBeneficiary?.relationship?.value?.toUpperCase() === 'DESIGNATED BENEFICIARY'
          ? 'OTHER'
          : contingentBeneficiary?.relationship?.value?.toUpperCase() === 'DOMESTIC PARTNER'
          ? 'SPOUSE'
          : contingentBeneficiary?.relationship?.value?.toUpperCase() === 'SELF'
          ? 'EMPLOYEE'
          : contingentBeneficiary?.relationship?.value
        : contingentBeneficiary?.relationship?.value;
      contingentBeneficiaryObject.policyOwner = false;
      contingentBeneficiaryObject.payor = false;
      contingentBeneficiaryObject.ssn = contingentBeneficiary.socialSecurityNumber.value;
      contingentBeneficiaryObject.employeeModel = {
        dateOfHire: '',
        employeeNumber: '',
        employer: '',
        occupation: '',
      };
      contingentBeneficiaryObject.employee = false;
      contingentBeneficiaryObject.height = '';
      contingentBeneficiaryObject.weight = '';
      contingentBeneficiaryObject.occupation = '';
      contingentBeneficiaryObject.emailAddress = '';
      contingentBeneficiaryObject.occSmokerCode = contingentBeneficiary.occSmokerCode.value;
      contingentBeneficiaryObject.crossReference = Math.round(generateRandomNumber(['1000000']) * 100000);

      let addContingentBeneficiary = true;

      clientListObject.forEach(item => {
        if (
          item?.relationshipToEmployee?.toUpperCase() === 'SPOUSE' &&
          contingentBeneficiaryObject?.relationshipToEmployee?.toUpperCase() === 'SPOUSE' &&
          item.dependent
        ) {
          item.beneficiary = true;
          item.beneficiaryPercent = contingentBeneficiary.percent;
          item.beneficiaryPersonType = 'Contingent Beneficiary';
          // item.signatureDate = item.signatureDate = contingentBeneficiary.signatureDate ? DateUtility.toIsoDate(contingentBeneficiary.signatureDate) : '';
          item.signatureDate = application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '';
          addContingentBeneficiary = false;
        } else if (
          item?.relationshipToEmployee?.toUpperCase() === 'CHILD' &&
          contingentBeneficiaryObject?.relationshipToEmployee?.toUpperCase() === 'CHILD' &&
          item.dependent &&
          ((item.ssn && item.ssn === contingentBeneficiaryObject.ssn) ||
            (item.firstName?.toLowerCase() === contingentBeneficiaryObject.firstName?.toLowerCase() &&
              item.lastName?.toLowerCase() === contingentBeneficiaryObject.lastName?.toLowerCase() &&
              item.middleName?.toLowerCase() === contingentBeneficiaryObject.middleName?.toLowerCase() &&
              item.dateOfBirth === contingentBeneficiaryObject.dateOfBirth))
        ) {
          item.beneficiary = true;
          item.beneficiaryPercent = contingentBeneficiary.percent;
          item.beneficiaryPersonType = 'Contingent Beneficiary';
          // item.signatureDate = contingentBeneficiary.signatureDate ? DateUtility.toIsoDate(contingentBeneficiary.signatureDate) : '';
          item.signatureDate = application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '';
          addContingentBeneficiary = false;
        }
      });

      if (addContingentBeneficiary) {
        if (contingentBeneficiaryObject.dateOfBirth.includes('NaN')) {
          contingentBeneficiaryObject.dateOfBirth = '';
        }
        if (
          contingentBeneficiaryObject.relationshipToEmployee === null &&
          contingentBeneficiaryObject.relationshipToPI === null
        ) {
          contingentBeneficiaryObject.relationshipToEmployee = '';
          contingentBeneficiaryObject.relationshipToPI = '';
        }
        clientListObject.push(contingentBeneficiaryObject);
      }
    });
  }

  if (productGroups !== null) {
    productGroups.forEach(item => {
      if (Object.keys(item).length === 0) {
        return;
      }
      if (
        applicationType === ApplicationType.Group &&
        item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]
      ) {
        if (
          mode === ApplicationModeType.Entry ||
          (mode === ApplicationModeType.Quality && application.planCodes.replaceProduct)
        ) {
          const planType = matchCriticalIllnessByType({
            Ordinary: ordinaryApp => ordinaryApp.planType.value,
            Group: grpApp => grpApp.planType.value,
            _: () => null,
          })(application.criticalIllness);

          if (planType === 'FAMILY' || planType === 'INDSPS') {
            let piDetails = clientListObject.filter(clientObj => clientObj.relationshipToPI === 'SELF');
            let spouseDetails = clientListObject.filter(clientObj => clientObj.relationshipToPI === 'SPOUSE');

            let piOccCode = '';
            piOccCode = application?.criticalIllness?.insuredSC.value;

            let spOccCode = '';
            spOccCode = application?.criticalIllness?.spouseSC.value;

            if (piOccCode === 'Non Smoker' && spOccCode === 'Non Smoker') {
              piDetails?.map((piDetail, idx) => (piDetail.occSmokerCode = 'Non Smoker'));
              spouseDetails?.map((spDetail, idx) => (spDetail.occSmokerCode = 'Non Smoker'));
            } else {
              piDetails?.map((piDetail, idx) => (piDetail.occSmokerCode = 'Smoker'));
              spouseDetails?.map((spDetail, idx) => (spDetail.occSmokerCode = 'Smoker'));
            }
          }
        }
      }
    });
  }

  if (productGroups !== null) {
    productGroups.forEach(item => {
      if (Object.keys(item).length === 0) {
        return;
      }
      const policy = {} as Policy;

      policy.productFamily = applicationType;
      policy.companyCode = item.companyCode!;
      policy.productCode = item.productCode!;
      policy.productGroup = item.productGroup!.toUpperCase();
      if (applicationType === ApplicationType.Group) {
        policy.groupAnswer = false;
      }
      policy.form =
        application.billingAgent.formNumber.key === 'UserAssignedFormNumber'
          ? {
              documentShortName: application.billingAgent.formNumber.documentShortName,
              fipscoDocumentName: application.billingAgent.formNumber.fipscoDocumentName,
              documentName: application.billingAgent.formNumber.documentName,
              documentLongName: application.billingAgent.formNumber.documentLongName,
              value: application.billingAgent.formNumber.value,
            }
          : ({} as Form);

      if (mode === ApplicationModeType.Quality) {
        totalOfPremium = getTotalPremium(
          application.premium,
          application.billingAgent.billingMode.value,
          application.premium.overrideAnnualPremium,
          Number(application.premium.annually.value)
        );
      }

      policy.policyNumber = getPolicyNumber(application.caseDetails.policyNumber, mode);

      //Group Critical Illness product riders configuration
      if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]) {
        const productType = matchCriticalIllnessByType({
          Ordinary: ordinaryApp => ordinaryApp.productType.value,
          Group: groupApp => groupApp.productType.value,
          _: () => null,
        })(application.criticalIllness);

        if (productType !== null) {
          policy.planCode = productType;
        }

        totalOfPremium = totalOfPremium + Number(application.criticalIllness.calculatedPremium.value);

        policy.baseUnits = 0;
        policy.forcedPremium = Number(application.criticalIllness.premium.value);

        policy.policyUnits = 0;
        policy.section125 = application.criticalIllness.section125;
        policy.perDeduction = Number(application.criticalIllness.calculatedPremium.value);
        policy.faceAmount = application.criticalIllness.benefitAmount;
        policy.monthlySalary = 0;
        policy.coverageLevel = application.criticalIllness.planType.value;
        policy.issueType = 'SI';
        policy.eeiIndicator = application.premium?.eeiIndicator;
        policy.cashWithApplication = {
          amount: Number(application.criticalIllness.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };

        const ridersList: Rider[] = [];

        if (applicationType === ApplicationType.Ordinary) {
          const riderCodeList = matchCriticalIllnessByType({
            Ordinary: ordinaryApp =>
              RI.isLoaded(ordinaryApp.riderInformation) ? ordinaryApp.riderInformation.Data.codes : I.List<string>(),
            _: () => null,
          })(application.criticalIllness);

          if (riderCodeList !== null) {
            riderCodeList.forEach((riderItem, riderIndex) => {
              if (riderItem !== undefined) {
                const riders = {} as Rider;

                riders.code = riderItem;

                const riderAmountList = matchCriticalIllnessByType({
                  Ordinary: ordinaryApp =>
                    RI.isLoaded(ordinaryApp.riderInformation)
                      ? ordinaryApp.riderInformation.Data.amounts
                      : I.List<string>(),
                  _: () => null,
                })(application.criticalIllness);
                riders.units = riderAmountList !== null ? Number(riderAmountList.get(riderIndex)) : 0;

                ridersList.push(riders);
              }
            });
            isReplacementPolicy = matchCriticalIllnessByType({
              Ordinary: ordinaryApp => ordinaryApp.replacement,
              _: () => false,
            })(application.criticalIllness);
            const cicr1Rider = matchCriticalIllnessByType({
              Ordinary: ordinaryApp => ordinaryApp.cicr1Rider,
              _: () => false,
            })(application.criticalIllness);
            if (cicr1Rider) {
              ridersList.push({code: 'CICR1', units: 0});
            }
          }
        }

        if (applicationType === ApplicationType.Group) {
          const cancer = matchCriticalIllnessByType({
            Group: grpApp => grpApp.cancer,
            _: () => false,
          })(application.criticalIllness);
          if (cancer) {
            ridersList.push({code: 'CICR1', units: 0});
          }
          isReplacementPolicy = matchCriticalIllnessByType({
            Group: groupApp => groupApp.replacement,
            _: () => false,
          })(application.criticalIllness);

          const reoccurance = matchCriticalIllnessByType({
            Group: grpApp => grpApp.recurrence,
            _: () => false,
          })(application.criticalIllness);
          if (reoccurance) {
            ridersList.push({code: 'CIHCR1', units: 0});
          }

          const wellness = matchCriticalIllnessByType({
            Group: grpApp => grpApp.wellnessUnits.value,
            _: () => null,
          })(application.criticalIllness);
          if (Number(wellness) > 0) {
            ridersList.push({code: 'WBR', units: Number(wellness)});
          }

          const criticalIllnessEnhancement = matchCriticalIllnessByType({
            Group: grpApp => grpApp.criticalIllnessEnhancement,
            _: () => false,
          })(application.criticalIllness);

          if (policy.planCode !== 'GVCIFX' && policy.planCode !== 'GVCIP4') {
            if (criticalIllnessEnhancement) {
              ridersList.push({code: 'GCCIER', units: 1});
            }
          }

          if (policy.planCode === 'GVCIP2') {
            const criticalIllnessChronic90day = matchCriticalIllnessByType({
              Group: grpApp => grpApp.chronic90Day,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessChronic90day) {
              ridersList.push({code: 'GCCIPR1', units: 0});
            }

            const criticalIllnessChronic365day = matchCriticalIllnessByType({
              Group: grpApp => grpApp.chronic365Day,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessChronic365day) {
              ridersList.push({code: 'GCCIPR2', units: 0});
            }
            const criticalIllnessContinuationOfCoverage = matchCriticalIllnessByType({
              Group: grpApp => grpApp.continuationCoverage,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessContinuationOfCoverage) {
              ridersList.push({code: 'GUCDSL', units: 0});
            }
            const criticalIllnessReturnOfPremium = matchCriticalIllnessByType({
              Group: grpApp => grpApp.returnOfPremium,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessReturnOfPremium) {
              ridersList.push({code: 'ROPL3', units: 1});
            }

            const criticalIllnessBenefit = matchCriticalIllnessByType({
              Group: grpApp => grpApp.ciBenefit.value,
              _: () => null,
            })(application.criticalIllness);
            if (Number(criticalIllnessBenefit) > 0) {
              ridersList.push({code: 'CIINC', units: Number(criticalIllnessBenefit)});
            }
          }

          if (policy.planCode === 'GVCIP4') {
            const criticalIllnessCIOption = matchCriticalIllnessByType({
              Group: grpApp => grpApp.ciOptionII,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessCIOption) {
              ridersList.push({code: 'CICR1', units: 0});
            }

            const criticalIllnessSecondEventCancer = matchCriticalIllnessByType({
              Group: grpApp => grpApp.secondEventCancer,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSecondEventCancer) {
              ridersList.push({code: 'CIHCR1', units: 0});
            }

            const criticalIllnessSecondEventCI = matchCriticalIllnessByType({
              Group: grpApp => grpApp.secondEventCI,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSecondEventCI) {
              ridersList.push({code: 'CIHCR2', units: 0});
            }

            const criticalIllnessTransportation = matchCriticalIllnessByType({
              Group: grpApp => grpApp.secondEvaluationTransportation,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessTransportation) {
              ridersList.push({code: 'GCIP4SER', units: 1});
            }

            const criticalIllnessSuppCIWithHIV = matchCriticalIllnessByType({
              Group: grpApp => grpApp.suppCIHIV,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSuppCIWithHIV) {
              ridersList.push({code: 'GCIP4SR1', units: 0});
            }

            const criticalIllnessSuppCIWithoutHIV = matchCriticalIllnessByType({
              Group: grpApp => grpApp.suppCI,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSuppCIWithoutHIV) {
              ridersList.push({code: 'GCIP4SR2', units: 0});
            }

            const criticalIllnessWellnessFixed = matchCriticalIllnessByType({        
              Group: grpApp => grpApp.fixedWellnessUnits.value,
              _: () => '',
            })(application.criticalIllness);
            if (criticalIllnessWellnessFixed) {
              ridersList.push({code: 'GCIP4FWR', units: Number(criticalIllnessWellnessFixed)});
            }

            const criticalIllnessWellnessPreventive = matchCriticalIllnessByType({
              Group: grpApp => grpApp.wellnessPreventiveCareUnits.value,
              _: () => '',
            })(application.criticalIllness);
            if (criticalIllnessWellnessPreventive) {
              ridersList.push({code: 'GCIP4WPR', units: Number(criticalIllnessWellnessPreventive)});
            }

            const criticalIllnessWellnessVariable = matchCriticalIllnessByType({
              Group: grpApp => grpApp.variableWellnessUnits.value,
              _: () => '',
            })(application.criticalIllness);
            if (criticalIllnessWellnessVariable) {
              ridersList.push({code: 'GCIP4VWR', units: Number(criticalIllnessWellnessVariable)});
            }

            const criticalIllnessSkinCancer = matchCriticalIllnessByType({
              Group: grpApp => grpApp.skinCancerUnit.value,
              _: () => '',
            })(application.criticalIllness);
            if (criticalIllnessSkinCancer) {
              ridersList.push({code: 'GCIP4SCR', units: Number(criticalIllnessSkinCancer)});
            }

            const criticalIllnessCardiopulmonaryEnhancement = matchCriticalIllnessByType({
              Group: grpApp => grpApp.cardiopulmonaryEnhancement,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessCardiopulmonaryEnhancement) {
              ridersList.push({code: 'GCIP4CER', units: 0});
            }

            const criticalIllnessChronicCI = matchCriticalIllnessByType({
              Group: grpApp => grpApp.specifiedChronicCI,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessChronicCI) {
              ridersList.push({code: 'GCIP4SC1R', units: 0});
            }

            const criticalIllnessChronicCIInjury = matchCriticalIllnessByType({
              Group: grpApp => grpApp.specifiedChronicCIInjury,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessChronicCIInjury) {
              ridersList.push({code: 'GCIP4SC2R', units: 0});
            }

            const criticalIllnessDieseaseEnhancement = matchCriticalIllnessByType({
              Group: grpApp => grpApp.specifiedDiseaseEnhancement,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessDieseaseEnhancement) {
              ridersList.push({code: 'GCIP4SDER', units: 0});
            }

            const criticalIllnessLifestyleEnhancement = matchCriticalIllnessByType({
              Group: grpApp => grpApp.lifestyleEnhancement,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessLifestyleEnhancement) {
              ridersList.push({code: 'GCIP4LER', units: 1});
            }
          }

          if (policy.planCode === 'GVCIFX' || policy.planCode === 'GVCIP2') {
            const criticalIllnessCIOption = matchCriticalIllnessByType({
              Group: grpApp => grpApp.ciOptionII,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessCIOption) {
              ridersList.push({code: 'CICR1', units: 0});
            }

            const criticalIllnessSecondEventCI = matchCriticalIllnessByType({
              Group: grpApp => grpApp.secondEventCI,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSecondEventCI) {
              ridersList.push({code: 'CIHCR2', units: 0});
            }

            const criticalIllnessSecondEventCancer = matchCriticalIllnessByType({
              Group: grpApp => grpApp.secondEventCancer,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSecondEventCancer) {
              ridersList.push({code: 'CIHCR1', units: 0});
            }

            const criticalIllnessSuppCIWithHIV = matchCriticalIllnessByType({
              Group: grpApp => grpApp.suppCIHIV,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSuppCIWithHIV) {
              ridersList.push({code: 'CISUPP1', units: 0});
            }

            const criticalIllnessSuppCIWithoutHIV = matchCriticalIllnessByType({
              Group: grpApp => grpApp.suppCI,
              _: () => false,
            })(application.criticalIllness);
            if (criticalIllnessSuppCIWithoutHIV) {
              ridersList.push({code: 'CISUPP2', units: 0});
            }
          }
        }

        policy.riders = ridersList;
        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium?.replacement;
          policy.planCode = application.planCodes.productType.value;
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.faceAmount = Number(application.planCodes.faceAmount.value);
          policy.monthlySalary = Number(application.planCodes.monthlySalary.value);
          policy.section125 = application.premium.section125;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.riders = getRidersInQuality(application.planCodes.planCodes, policy.faceAmount);
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
        }
      }
      //Group Cancer Product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Cancer]) {
        const planCode = matchCancerByType({
          Ordinary: ordinaryApp => ordinaryApp.productType.value,
          Group: groupApp => groupApp.plan.value,
          _: () => null,
        })(application.cancer);

        isReplacementPolicy = matchCancerByType({
          Ordinary: ordinaryApp => ordinaryApp.replacement,
          Group: groupApp => groupApp.replacement,
          _: () => false,
        })(application.cancer);
        if (isReplacementPolicy) {
          policy.originalPolicyNumber = matchCancerByType({
            Ordinary: ordinaryApp =>
              ordinaryApp.policyNumber.key === 'ValidPolicyNumber' ? ordinaryApp.policyNumber.value.value : '',
            Group: groupApp =>
              groupApp.policyNumber.key === 'ValidPolicyNumber' ? groupApp.policyNumber.value.value : '',
            NewYork: () => '',
          })(application.cancer);
        }

        const policyUnits = matchCancerByType({
          Ordinary: ordinaryApp => ordinaryApp.policyOption.value,
          Group: groupApp => groupApp.planOption.value,
          _: () => null,
        })(application.cancer);

        const baseUnits = matchCancerByType({
          Group: groupApp => groupApp.baseUnits.value,
          _: () => null,
        })(application.cancer);

        totalOfPremium = totalOfPremium + Number(application.cancer.calculatedPremium.value);

        policy.planCode = planCode === null ? '' : planCode;
        if (planCode === 'CP12') {
          policy.baseUnits = policyUnits == null ? 0 : Number(policyUnits);
        } else {
          policy.baseUnits = baseUnits == null ? 0 : Number(baseUnits);
        }
        policy.forcedPremium = Number(application.cancer.premium.value);

        if (applicationType === ApplicationType.Group) {
          policy.planOption = policyUnits === null ? '' : policyUnits;
        }

        policy.policyUnits = 0;
        if (planCode === 'CP10') {
          policy.planOption = policyUnits === null ? '' : policyUnits;
        }
        policy.perDeduction = Number(application.cancer.calculatedPremium.value);

        policy.section125 = application.cancer.section125;
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.coverageLevel = application.cancer.planType.value;
        policy.issueType = 'SI';
        policy.eeiIndicator = application.premium?.eeiIndicator;
        const ridersList: Rider[] = [];
        const defaultRiderCodes = ['RAD', 'SURG', 'MISC'];
        policy.cashWithApplication = {
          amount: Number(application.cancer.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };

        const riderCodes = matchCancerByType({
          Ordinary: ordinaryApp =>
            RI.isLoaded(ordinaryApp.riderInformation) ? ordinaryApp.riderInformation.Data.codes : I.List<string>(),
          Group: groupApp => groupApp.riderInformation.codes,
          NewYork: newYorkApp => newYorkApp.riderInformation.codes,
        })(application.cancer);

        const riderAmounts = matchCancerByType({
          Ordinary: ordinaryApp =>
            RI.isLoaded(ordinaryApp.riderInformation) ? ordinaryApp.riderInformation.Data.amounts : I.List<string>(),
          Group: groupApp => groupApp.riderInformation.amounts,
          NewYork: newYorkApp => newYorkApp.riderInformation.amounts,
        })(application.cancer);

        if (planCode === 'CP12') {
          defaultRiderCodes.forEach(riderItem => {
            const riders = {} as Rider;
            if (riderItem === 'MISC') {
              riders.units = 1;
            } else {
              riders.units = Number(policyUnits);
            }

            riders.code = riderItem;

            ridersList.push(riders);
          });
        }

        riderCodes.forEach((riderItem, riderIndex) => {
          const riders = {} as Rider;

          if (riderItem !== undefined && !isNaN(Number(riderAmounts.get(riderIndex)))) {
            riders.code = riderItem;
            if (riders.code === 'Return of Premium') {
              riders.code = 'ROPL3';
            }
            if (riders.code === 'Continuation of Coverage') {
              riders.code = 'GUCDSL';
            }
            riders.units = Number(riderAmounts.get(riderIndex));
            ridersList.push(riders);
          }
        });
        policy.riders = ridersList;
        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium?.replacement;
          policy.planCode = application.planCodes.productType.value;
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.policyUnits = Number(application.planCodes.planCodes[0].units);
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.riders = getRidersInQuality(application.planCodes.planCodes);

          policy.planOption = application.planCodes.planOption.value;
          policy.section125 = application.premium.section125;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
        }
      }
      //Group Accident Product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Accident]) {
        let planCode: string = '';
        policy.monthlyBenefit = 0;

        totalOfPremium = Number(application.accident.calculatedPremium.value);

        policy.forcedPremium = Number(application.accident.premium.value);
        policy.perDeduction = totalOfPremium;
        policy.baseUnits = Number(application.accident.baseUnits.value);
        policy.policyUnits = Number(application.accident.baseUnits.value);
        policy.section125 = application.accident.section125;
        policy.coverageLevel = application.accident.planType.value;
        policy.eeiIndicator = application.premium?.eeiIndicator;
        policy.cashWithApplication = {
          amount: Number(application.accident.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };
        policy.occupationalClass = matchAccidentByType({
          Group: groupApp =>
            groupApp.occClass.key === 'Loaded' ? groupApp.occClass.Data.saldOccClassInfo.originalOccClass : '',
          _: () => '',
        })(application.accident);

        planCode = matchAccidentByType({
          Ordinary: ordinaryApp => ordinaryApp.productType.value,
          Group: groupApp => groupApp.plan.value,
          NewYork: newYorkApp => newYorkApp.plan.value,
        })(application.accident);

        const selectCGI = matchAccidentByType({
          Ordinary: ordinaryApp => ordinaryApp.selectCgi,
          Group: () => false,
          NewYork: () => false,
        })(application.accident);

        const monthlySalary = matchAccidentByType({
          Ordinary: ordinaryApp => Number(ordinaryApp.monthlySalary.value),
          Group: () => 0,
          NewYork: () => 0,
        })(application.accident);

        policy.planCode = planCode === null ? '' : planCode;
        policy.monthlySalary = monthlySalary === null ? 0 : monthlySalary;
        policy.issueType = selectCGI ? 'CGI' : 'SI';

        isReplacementPolicy = matchAccidentByType({
          Ordinary: ordinaryApp => ordinaryApp.replacement,
          Group: groupApp => groupApp.replacement,
          _: () => false,
        })(application.accident);
        if (isReplacementPolicy) {
          policy.originalPolicyNumber = matchAccidentByType({
            Ordinary: ordinaryApp =>
              ordinaryApp.policyNumber.key === 'ValidPolicyNumber' ? ordinaryApp.policyNumber.value.value : '',
            Group: groupApp =>
              groupApp.policyNumber.key === 'ValidPolicyNumber' ? groupApp.policyNumber.value.value : '',
            NewYork: () => '',
          })(application.accident);
        }

        let riders: Rider[] = [];

        riders = handleAccidentRiders(application.accident);

        if (applicationType === ApplicationType.Group) {
          const groupAccidentRiders = application.accident as GroupAccident;

          const continuationCoverage = matchAccidentByType({
            Group: grpApp => grpApp.continuationOfCoverage,
            _: () => false,
          })(application.accident);
          if (continuationCoverage) {
            riders.push({code: 'GUCDSL', units: Number(continuationCoverage)});
          }

          if (policy.planCode !== 'GVAP6') {
            if (groupAccidentRiders.returnOfPremium) {
              const returnPremium = matchAccidentByType({
                Group: grpApp => grpApp.returnOfPremium,
                _: () => false,
              })(application.accident);
              if (returnPremium) {
                riders.push({code: 'ROPL3', units: Number(returnPremium)});
              }
            }
          }

          if (policy.planCode === 'GVAP1' || policy.planCode === 'GVA1FD') {
            if (groupAccidentRiders.offJobAccident) {
              const offJobAccident = matchAccidentByType({
                Group: grpApp => grpApp.employee.value,
                _: () => '',
              })(application.accident);
              if (offJobAccident) {
                riders.push({code: 'R1AP', units: Number(offJobAccident)});
              }
            }

            if (groupAccidentRiders.onOffJobAccident) {
              const onOffJobAccident = matchAccidentByType({
                Group: grpApp => grpApp.employee.value,
                _: () => '',
              })(application.accident);
              if (onOffJobAccident) {
                riders.push({code: 'R2AP', units: Number(onOffJobAccident)});
              }
            }

            if (groupAccidentRiders.offJobAccidentSickness) {
              const offJobAccidentSickness = matchAccidentByType({
                Group: grpApp => grpApp.employee.value,
                _: () => '',
              })(application.accident);
              if (offJobAccidentSickness) {
                riders.push({code: 'R3AP', units: Number(offJobAccidentSickness)});
              }
            }

            if (groupAccidentRiders.onOffJobAccidentSickness) {
              const onOffJobAccidentSickness = matchAccidentByType({
                Group: grpApp => grpApp.employee.value,
                _: () => '',
              })(application.accident);
              if (onOffJobAccidentSickness) {
                riders.push({code: 'R4AP', units: Number(onOffJobAccidentSickness)});
              }
            }

            if (groupAccidentRiders.onOffJobAccidentInsuredSpouse) {
              const onOffJobAccidentSpouse = matchAccidentByType({
                Group: grpApp => grpApp.spouse.value,
                _: () => '',
              })(application.accident);
              if (onOffJobAccidentSpouse) {
                riders.push({code: 'R5AP', units: Number(onOffJobAccidentSpouse)});
              }
            }

            if (groupAccidentRiders.onOffJobAccidentSicknessInsuredSpouse) {
              const onOffJobAccidentSicknessSpouse = matchAccidentByType({
                Group: grpApp => grpApp.spouse.value,
                _: () => '',
              })(application.accident);
              if (onOffJobAccidentSicknessSpouse) {
                riders.push({code: 'R6AP', units: Number(onOffJobAccidentSicknessSpouse)});
              }
            }
          }

          if (
            policy.planCode === 'GVAP1' ||
            policy.planCode === 'GVA1FD' ||
            policy.planCode === 'GVAP2' ||
            policy.planCode === 'GVA2FD'
          ) {
            const berVersion = matchAccidentByType({
              Group: grpApp => grpApp.berUnits.value,
              _: () => '',
            })(application.accident);
            if (berVersion) {
              riders.push({code: 'BER', units: Number(berVersion)});
            }
          }

          if (policy.planCode === 'GVAP2' || policy.planCode === 'GVA2FD' || policy.planCode === 'GVAP6') {
            if (groupAccidentRiders.hsa.value === 'N') {
              policy.hsa = false;
              const outpatientPhysicianRider = matchAccidentByType({
                Group: grpApp => grpApp.oprUnits.value,
                _: () => '',
              })(application.accident);
              if (outpatientPhysicianRider) {
                riders.push({code: 'OPR', units: Number(outpatientPhysicianRider)});
              }
            }

            if (groupAccidentRiders.hsa.value === 'Y') {
              policy.hsa = true;
              const outpatientPhysicianRider = matchAccidentByType({
                Group: grpApp => grpApp.oprUnits.value,
                _: () => '',
              })(application.accident);
              if (outpatientPhysicianRider) {
                riders.push({code: 'OPH', units: Number(outpatientPhysicianRider)});
              }
            }
          }

          if (policy.planCode === 'GVAP6') {
            if (groupAccidentRiders.coverageTier.value === '2') {
              policy.coverageTier = 2;
            } else if (groupAccidentRiders.coverageTier.value === '4') {
              policy.coverageTier = 4;
            }
            const accTreatUrgent = matchAccidentByType({
              Group: grpApp => grpApp.accTreatmentUcUnits.value,
              _: () => '',
            })(application.accident);
            if (accTreatUrgent) {
              riders.push({code: 'GP6AUC', units: Number(accTreatUrgent)});
            }

            const emerRoomService = matchAccidentByType({
              Group: grpApp => grpApp.emerRoomSerUnits.value,
              _: () => '',
            })(application.accident);
            if (emerRoomService) {
              riders.push({code: 'GP6ERS', units: Number(emerRoomService)});
            }

            const outpatPhysician = matchAccidentByType({
              Group: grpApp => grpApp.outpatientPhyUnits.value,
              _: () => '',
            })(application.accident);
            if (outpatPhysician) {
              riders.push({code: 'GP6OPT', units: Number(outpatPhysician)});
            }

            const dislocFracture = matchAccidentByType({
              Group: grpApp => grpApp.dislocFractureUnits.value,
              _: () => '',
            })(application.accident);
            if (dislocFracture) {
              riders.push({code: 'GP6DF', units: Number(dislocFracture)});
            }

            const benefitEnhance = matchAccidentByType({
              Group: grpApp => grpApp.berUnits.value,
              _: () => '',
            })(application.accident);
            if (benefitEnhance) {
              riders.push({code: 'GP6BE', units: Number(benefitEnhance)});
            }

            const accDismember = matchAccidentByType({
              Group: grpApp => grpApp.accDeathDisUnits.value,
              _: () => '',
            })(application.accident);
            if (accDismember) {
              riders.push({code: 'GP6ADD', units: Number(accDismember)});
            }
          }
        }
        policy.riders = riders;

        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium.replacement;
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          planCode = application.planCodes.productType.value;
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.baseUnits = application.planCodes.planCodes[0].units;
          policy.policyUnits = application.planCodes.planCodes[0].units;
          policy.riders = handleRidersInQuality(application.planCodes.planCodes);
          policy.section125 = application.premium.section125;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          let planCodeAP2C = application.planCodes.planCodes.some(
            item => item.planCode === 'AP2IXN' || item.planCode === 'AP2FXN'
          );
          let planCodeAP3C = application.planCodes.planCodes.some(
            item => item.planCode === 'AP3IXN' || item.planCode === 'AP3FXN'
          );

          if (planCodeAP2C) {
            policy.planCode = 'AP2C';
          } else if (planCodeAP3C) {
            policy.planCode = 'AP3C';
          } else if (application.planCodes.planCodes.some(item => item.planCode.startsWith('SAP2'))) {
            policy.planCode = 'SAP2';
          } else {
            policy.planCode = application.planCodes.productType.value;
          }

          totalOfPremium = Number(application.premium.annually.value);

          policy.perDeduction = totalOfPremium;

          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.issueType = application.planCodes.issueType.value;
          if (policy.issueType === '' && (policy.planCode === 'SAP2' || policy.planCode === 'SAP3')) {
            policy.issueType = 'SI';
          }
        }
      }
      //Disability product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Disability]) {
        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium?.replacement;
          policy.planCode = application.planCodes.productType.value;
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.section125 = application.premium.section125;
          policy.issueType = application.planCodes.issueType.value;
          policy.monthlySalary = Number(application.planCodes.monthlySalary.value);
          policy.faceAmount = Number(application.planCodes.monthlyBenefit.value);
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
          policy.riders = getRidersInQuality(application.planCodes.planCodes);
          policy.eliminationPeriod =
            '' +
            Number(application.additionalProperties.eliminationPeriod.value.substr(0, 3)) +
            Number(application.additionalProperties.eliminationPeriod.value.substr(3));
          policy.benefitPeriod = application.additionalProperties.benefitPeriod;
          const  OccSmokerCode = clientListObject.find(O => O.proposedInsured == true)?.occSmokerCode.toString();
          policy.disabilityOccupationalClass = OccSmokerCode === undefined ? "S": OccSmokerCode;
          policy.occupationalClass = application.additionalProperties.occClass?.value!;
          policy.mentalNervousExclusion = application.additionalProperties.mentalNervousExclusion?.value!;
        } else {
          isReplacementPolicy = matchDisabilityByType({
            Group: groupApp => groupApp.replacement,
            _: () => false,
          })(application.disability);
          totalOfPremium = totalOfPremium + Number(application.disability.calculatedPremium.value);
          policy.baseUnits = 0;
          policy.forcedPremium = Number(application.disability.premium.value);
          policy.policyUnits = 0;
          policy.section125 = application.disability.section125;
          policy.perDeduction = Number(application.disability.calculatedPremium.value);
          policy.issueType = application.planCodes.issueType.value;
          policy.monthlyBenefit = Number(application.disability.monthlyBenefit.value);
          policy.monthlySalary = Number(application.disability.monthlySalary.value);
          policy.coverageLevel = 'Individual';
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.benefitPeriod = Number(application.disability.benefitPeriod.value);
          policy.cashWithApplication = {
            amount: Number(application.disability.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
          policy.eliminationPeriod =
            '' + Number(application.disability.accident.value) + Number(application.disability.sickness.value);

          policy.faceAmount = Number(application.disability.monthlyBenefit.value);

          let riders: Rider[] = [];

          //ordinary disability details

          if (applicationType === ApplicationType.Ordinary) {
            const issueType = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.type.value,
              _: () => null,
            })(application.disability);
            policy.issueType = issueType === 'Simplified' ? 'SI' : 'CGI';
 
            const planCode = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.plan.value,
              _: () => null,
            })(application.disability);
            policy.planCode = planCode === null ? '' : planCode;

            const riderType = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.riderType.value,
              _: () => null,
            })(application.disability);

            const mentalNervousRider = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.mentalNervousRider,
              _: () => null,
            })(application.disability);
            if (mentalNervousRider) {
              riders.push({code: 'MDIR1', units: 0});
            }

            const monthlyBenefit = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.monthlyBenefit.value,
              _: () => null,
            })(application.disability);

            const onJobRider = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.onJobRider,
              _: () => null,
            })(application.disability);

            const onJobRiderMonthly = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.onJobRiderMonthly.value,
              _: () => null,
            })(application.disability);
            if (onJobRider) {
              const onJobRiderUnit = Number(onJobRiderMonthly) / 100;
              riders.push({code: 'R1DI5', units: Number(onJobRiderUnit)});
            }

            const accidentRiderUnits = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.accidentRiderUnit,
              _: () => null,
            })(application.disability);
            if (accidentRiderUnits && accidentRiderUnits >= 0) {
              riders.push({code: 'ABR1', units: Number(accidentRiderUnits)});
            }

            policy.disabilityOccupationalClass = matchDisabilityByType({
              Ordinary: ordinaryApp => ordinaryApp.occClass.value,
              _: () => '',
            })(application.disability);
          }

          //Group Disability details
          if (applicationType === ApplicationType.Group) {
            policy.occupationalClass = matchDisabilityByType({
              Group: groupApp =>
                groupApp.occClass.key === 'Loaded' ? groupApp.occClass.Data.saldOccClassInfo.originalOccClass : '',
              _: () => '',
            })(application.disability);

            const planCode = matchDisabilityByType({
              Group: groupApp => groupApp.plan.value,
              _: () => null,
            })(application.disability);
            policy.planCode = planCode === null ? '' : planCode;
            policy.issueType = 'SI';

            const gcropr1Rider = matchDisabilityByType({
              Group: groupApp => groupApp.gcroprRider,
              _: () => false,
            })(application.disability);
            if (gcropr1Rider) {
              riders.push({code: 'GCROPR', units: Number(gcropr1Rider)});
            }

            const oadrRider = matchDisabilityByType({
              Group: groupApp => groupApp.oadr1Rider,
              _: () => false,
            })(application.disability);
            if (oadrRider) {
              riders.push({code: 'OADR1', units: Number(oadrRider)});
            }

            const fmdrRider = matchDisabilityByType({
              Group: groupApp => groupApp.fmdr1Rider,
              _: () => false,
            })(application.disability);
            if (fmdrRider) {
              riders.push({code: 'FMDR1', units: Number(fmdrRider)});
            }

            const ibdrRider = matchDisabilityByType({
              Group: groupApp => groupApp.ibdr1Rider,
              _: () => false,
            })(application.disability);
            if (ibdrRider) {
              riders.push({code: 'IBDR1', units: Number(ibdrRider)});
            }

            const sadr1Rider = matchDisabilityByType({
              Group: groupApp => groupApp.sadrRider,
              _: () => false,
            })(application.disability);
            if (sadr1Rider) {
              riders.push({code: 'SADR1', units: Number(sadr1Rider)});
            }
          }
          policy.riders = riders;
        }
      }
      //Shop Product Riders Configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Shop]) {
        isReplacementPolicy = matchShopByType({
          Group: groupApp => groupApp.replacement,
          _: () => false,
        })(application.shop);
        policy.policyUnits = 0;
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.planCode = 'CHC';

        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium?.replacement;
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.issueType = application.planCodes.issueType.value;
          policy.section125 = application.premium.section125;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
          if (applicationType === ApplicationType.Group) {
            policy.planCode = application.planCodes.productType.value;
            policy.policyUnits = policy.baseUnits;
          }
          policy.riders = getRidersInQuality(application.planCodes.planCodes);

          if (policy.planCode === 'GVSP1') {
            policy.riders.forEach(rider => {
              if (rider.code === 'SURG') {
                policy.riders.push({code: 'HOSP', units: rider.units});
              }
            });
          }
        } else {
          if (applicationType === ApplicationType.Ordinary) {
            const baseUnit = matchShopByType({
              Ordinary: ordinaryApp => ordinaryApp.baseUnit,

              _: () => null,
            })(application.shop);
            const selectCGI = matchShopByType({
              Ordinary: ordinaryApp => ordinaryApp.selectCGI,

              _: () => null,
            })(application.shop);
            policy.baseUnits = baseUnit === null ? 0 : baseUnit;
            policy.issueType = selectCGI ? 'CGI' : 'SI';
          }
          if (applicationType === ApplicationType.Group) {
            const planCode = matchShopByType({
              Group: groupApp => groupApp.plan.value,
              _: () => null,
            })(application.shop);
            policy.planCode = planCode === null ? '' : planCode;
            policy.issueType = 'SI';
          }

          const premium = matchShopByType({
            Ordinary: ordinaryApp => ordinaryApp.calculatedPremium.value,
            Group: grpApp => grpApp.calculatedPremium.value,
            _: () => null,
          })(application.shop);
          const section125 = matchShopByType({
            Ordinary: ordinaryApp => ordinaryApp.section125,
            Group: grpApp => grpApp.section125,

            _: () => false,
          })(application.shop);

          const planType = matchShopByType({
            Ordinary: ordinaryApp => ordinaryApp.planType.value,
            Group: grpApp => grpApp.planType.value,
            _: () => null,
          })(application.shop);
          totalOfPremium = totalOfPremium + Number(premium);

          policy.perDeduction = Number(premium);
          policy.forcedPremium = Number(application.shop.premium.value);
          policy.cashWithApplication = {
            amount: Number(application.shop.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          policy.section125 = section125;

          policy.coverageLevel = planType === null ? '' : planType;
          policy.eeiIndicator = application.premium?.eeiIndicator;

          const ridersList: Rider[] = [];

          const riderCodes = matchShopByType({
            Ordinary: ordinaryApp => ordinaryApp.riderInformation.codes,
            Group: groupApp => groupApp.riderInformation.codes,
            NewYork: newYorkApp => newYorkApp.riderCodeList,
          })(application.shop);

          const riderAmounts = matchShopByType({
            Ordinary: ordinaryApp => ordinaryApp.riderInformation.amounts,
            Group: groupApp => groupApp.riderInformation.amounts,
            NewYork: newYorkApp => newYorkApp.riderAmounts,
          })(application.shop);

          riderCodes.forEach((riderItem, riderIndex) => {
            const riders = {} as Rider;

            riders.code = riderItem;
            riders.units = Number(riderAmounts.get(riderIndex));
            if (riderItem !== undefined) {
              if (riders.code === 'Return of Premium') {
                riders.code = 'ROPL3';
              }
              if (riders.code === 'Continuation of Coverage') {
                riders.code = 'GUCDSL';
              }
              if (riderItem === 'SURG') {
                policy.baseUnits = riders.units;
                policy.policyUnits = riders.units;
              }
              if (riderItem === 'GVSP2') {
                policy.baseUnits = riders.units;
                policy.policyUnits = riders.units;
              } else {
                ridersList.push(riders);
              }
            }
          });
          policy.riders = ridersList;
        }
      }
      //Heartstroke product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.HeartStroke]) {
        totalOfPremium = totalOfPremium + Number(application.heartStroke.calculatedPremium.value);

        policy.planCode = 'HSP2';
        policy.baseUnits = Number(application.heartStroke.baseUnits);
        policy.perDeduction = Number(application.heartStroke.calculatedPremium.value);
        policy.forcedPremium = Number(application.heartStroke.premium.value);
        policy.policyUnits = 0;
        policy.section125 = application.heartStroke.section125;
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.coverageLevel = application.heartStroke.planType.value;
        policy.cashWithApplication = {
          amount: Number(application.heartStroke.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };
        policy.policyNumber = matchHeartStrokeByType({
          Ordinary: ordinaryApp =>
            ordinaryApp.policyNumber.key === 'ValidPolicyNumber'
              ? ordinaryApp.policyNumber.value.value
              : application.caseDetails.policyNumber.key === 'Loaded'
              ? application.caseDetails.policyNumber.Data
              : '',
          Group: () =>
            application.caseDetails.policyNumber.key === 'Loaded' ? application.caseDetails.policyNumber.Data : '',
          NewYork: () =>
            application.caseDetails.policyNumber.key === 'Loaded' ? application.caseDetails.policyNumber.Data : '',
        })(application.heartStroke);
        const ridersList: Rider[] = [];

        const riderCodes = matchHeartStrokeByType({
          Ordinary: ordinaryApp => ordinaryApp.riderInformation.codes,
          Group: groupApp => groupApp.riderCodeList,
          NewYork: newYorkApp => newYorkApp.riderCodeList,
        })(application.heartStroke);

        const riderAmounts = matchHeartStrokeByType({
          Ordinary: ordinaryApp => ordinaryApp.riderInformation.amounts,
          Group: groupApp => groupApp.riderAmounts,
          NewYork: newYorkApp => newYorkApp.riderAmounts,
        })(application.heartStroke);

        riderCodes.forEach((riderItem, riderIndex) => {
          const riders = {} as Rider;

          riders.code = riderItem;
          riders.units = Number(riderAmounts.get(riderIndex));

          ridersList.push(riders);
        });
        policy.riders = ridersList;
      }
      //IWL product configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Iwl]) {
        isReplacementPolicy = matchIWLByType({
          Ordinary: ordApp => ordApp.replacement,
          _: () => false,
        })(application.iwl);
        policy.coverageLevel = 'IND';
        policy.occupationalClass = matchIWLByType({
          Ordinary: ordinaryApp =>
            ordinaryApp.occClass.key === 'Loaded' ? ordinaryApp.occClass.Data.saldOccClassInfo.originalOccClass : '',
          _: () => '',
        })(application.iwl);

        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium?.replacement;
          policy.planCode = item.productGroup!.toUpperCase();
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.policyUnits = 0;
          policy.issueType = application.planCodes.issueType.value;
          policy.faceAmount = Number(application.planCodes.faceAmount.value);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
          policy.riders = getRidersInQuality(application.planCodes.planCodes, policy.faceAmount);
        } else {
          const premium = matchIWLByType({
            Ordinary: ordinaryApp => ordinaryApp.calculatedPremium,
            _: () => null,
          })(application.iwl);

          totalOfPremium = totalOfPremium + Number(premium);

          policy.planCode = item.productGroup!.toUpperCase();
          policy.baseUnits = 0;
          policy.forcedPremium = Number(application.iwl.premium.value);
          policy.policyUnits = 0;
          policy.issueType = application.iwl.type.value;
          policy.faceAmount = Number(application.iwl.faceAmt.value);
          policy.perDeduction = Number(premium === null ? 0 : premium.value);
          policy.monthlyBenefit = 0;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.monthlySalary = 0;
          policy.cashWithApplication = {
            amount: Number(application.iwl.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          const ridersList: Rider[] = [];

          const riderCodes = matchIWLByType({
            Ordinary: ordinaryApp => ordinaryApp.riderInformation.codes,
            Group: groupApp => groupApp.riderInformation.codes,
            NewYork: newYorkApp => newYorkApp.riderCodes,
          })(application.iwl);

          const riderAmounts = matchIWLByType({
            Ordinary: ordinaryApp => ordinaryApp.riderInformation.amounts,
            Group: groupApp => groupApp.riderInformation.amounts,
            NewYork: newYorkApp => newYorkApp.riderAmounts,
          })(application.iwl);

          riderCodes.forEach((riderItem, riderIndex) => {
            if (riderAmounts.get(riderIndex) !== undefined) {
              const riders = {} as Rider;

              riders.code = riderItem;

              riders.units = Number(riderAmounts.get(riderIndex));

              ridersList.push(riders);
            }
          });
          policy.riders = ridersList;
        }
      } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Icrtn]) {
        totalOfPremium = totalOfPremium + Number(application.icrtn.calculatedPremium.value);

        policy.planCode = application.icrtn.productType.value;
        policy.baseUnits = 0;
        policy.forcedPremium = Number(application.icrtn.premium.value);
        policy.policyUnits = 0;
        policy.section125 = application.icrtn.section125;
        policy.perDeduction = Number(application.icrtn.calculatedPremium.value);
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.coverageLevel = application.icrtn.planType.value;
        policy.cashWithApplication = {
          amount: Number(application.icrtn.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };
      }
      //GUL Product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.UniversalLife]) {
        isReplacementPolicy = matchULByType({
          Group: groupApp => groupApp.replacement,
          _: () => false,
        })(application.universalLife);

        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium.replacement;
          policy.planCode = application.planCodes.productType.value;
          policy.baseUnits = 0;
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.policyUnits = 0;
          policy.issueType = application.planCodes.issueType.value;
          policy.faceAmount = Number(application.planCodes.faceAmount.value);
          totalOfPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.perDeduction = totalOfPremium;
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.deathBenefit = application.premium.deathBenefit;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.replacementPremium = application.premium.replacementPremium;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          policy.riders = getRidersInQuality(application.planCodes.planCodes, policy.faceAmount);
        } else {
          totalOfPremium = totalOfPremium + Number(application.universalLife.calculatedPremium.value);

          policy.planCode = 'GUL23';
          policy.baseUnits = 0;
          policy.forcedPremium = Number(application.universalLife.premium.value);
          policy.faceAmount = Number(application.universalLife.faceAmt.value);
          policy.policyUnits = 0;
          policy.section125 = false;
          policy.perDeduction = Number(application.universalLife.calculatedPremium.value);
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;

          let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

          let numberOfPays = 0;

          if (application.billingAgent.billingMode.value === '') {
            numberOfPays = application.billingModes.billingModes
              .flatMap(m => m.occurrences)
              .find(x => x.name.toUpperCase() === billingCode?.value.toUpperCase())?.frequency!;
          } else {
            numberOfPays = application.billingModes.billingModes
              .flatMap(m => m.occurrences)
              .find(x => x.name.toUpperCase() === application.billingAgent.billingMode.value.toUpperCase())?.frequency!;
          }

          const replacementPremium = (Number(application.universalLife.premium.value) * numberOfPays) / 1.5;

          if (application.universalLife.commission.value === 'First Year Commissions') {
            policy.replacementPremium = replacementPremium - 1;
          } else if (application.universalLife.commission.value === 'Renewal Commissions') {
            policy.replacementPremium = replacementPremium + 1;
          }

          policy.cashWithApplication = {
            amount: Number(application.universalLife.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          policy.coverageLevel = 'IND';
          policy.deathBenefit =
            application.universalLife.deathBenefit.value === 'Option 1'
              ? 1
              : application.universalLife.deathBenefit.value === 'Option 2'
              ? 2
              : 0;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          switch (application.universalLife.plan.value) {
            case 'GUL23':
              policy.issueType = 'SI';
              break;
            case 'SUL23':
              policy.issueType = 'CGI';
              break;
            case 'GIUL23':
              policy.issueType = 'GI';
              break;
          }

          const ridersList: Rider[] = [];

          const riderCodes = matchULByType({
            Ordinary: ordinaryApp => ordinaryApp.riderCodes,
            Group: groupApp => groupApp.riderInformation.codes,
            NewYork: newYorkApp => newYorkApp.riderCodes,
          })(application.universalLife);

          const riderAmounts = matchULByType({
            Ordinary: ordinaryApp => ordinaryApp.riderAmounts,
            Group: groupApp => groupApp.riderInformation.amounts,
            NewYork: newYorkApp => newYorkApp.riderAmounts,
          })(application.universalLife);

          riderCodes.forEach((riderItem, riderIndex) => {
            if (riderItem !== undefined) {
              if (riderAmounts.get(riderIndex) !== null) {
                const riders = {} as Rider;

                if (riderItem === 'GULTCEXT+GULTC') {
                  riders.code = 'GULTCEXT';
                } else if (riderItem === 'GULTC') {
                  const situs =
                    groupBillingAgentState && groupBillingAgentState !== application.applicantDemographics.state.value
                      ? groupBillingAgentState || situsState.value
                      : application.applicantDemographics.state.value;

                  if (situs === 'FL') {
                    riders.code = 'GULTCFL';
                  } else {
                    riders.code = riderItem;
                  }
                } else {
                  riders.code = riderItem;
                }

                riders.units = Number(riderAmounts.get(riderIndex));
                if (!(riders.code === 'GUADB' && riders.units === 0)) {
                  ridersList.push(riders);
                }
              }
            }
          });

          policy.riders = ridersList;
        }
      }
      //GWL product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Gwl]) {
        policy.occupationalClass = matchIWLByType({
          Group: groupApp =>
            groupApp.occClass.key === 'Loaded' ? groupApp.occClass.Data.saldOccClassInfo.originalOccClass : '',
          _: () => '',
        })(application.iwl);
        isReplacementPolicy = matchIWLByType({
          Group: groupApp => groupApp.replacement,
          _: () => false,
        })(application.iwl);
        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium?.replacement;
          policy.planCode = item.productGroup!.toUpperCase();
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.policyUnits = 0;
          policy.issueType = application.planCodes.issueType.value;
          policy.faceAmount = Number(application.planCodes.faceAmount.value);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.riders = getRidersInQuality(application.planCodes.planCodes, policy.faceAmount);
        } else {
          const premium = matchIWLByType({
            Group: groupApp => groupApp.calculatedPremium,
            _: () => null,
          })(application.iwl);

          totalOfPremium = totalOfPremium + Number(premium);

          policy.planCode = item.productGroup!.toUpperCase();
          policy.baseUnits = 0;
          policy.forcedPremium = Number(application.iwl.premium.value);
          policy.policyUnits = 0;
          policy.issueType = application.iwl.type.value;
          policy.faceAmount = Number(application.iwl.faceAmt.value);
          policy.perDeduction = Number(premium === null ? 0 : premium.value);
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.iwl.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };
          policy.section125 = false;
          policy.coverageLevel = matchIWLByType({
            Group: groupApp => groupApp.coverageLevel.value,
            _: () => '',
          })(application.iwl);

          totalOfPremium = totalOfPremium + Number(application.iwl.calculatedPremium.value);

          const ridersList: Rider[] = [];

          const riderCodes = matchIWLByType({
            Ordinary: ordinaryApp => ordinaryApp.riderInformation.codes,
            Group: groupApp => groupApp.riderInformation.codes,
            NewYork: newYorkApp => newYorkApp.riderCodes,
          })(application.iwl);

          const riderAmounts = matchIWLByType({
            Ordinary: ordinaryApp => ordinaryApp.riderInformation.amounts,
            Group: groupApp => groupApp.riderInformation.amounts,
            NewYork: newYorkApp => newYorkApp.riderAmounts,
          })(application.iwl);

          riderCodes.forEach((riderItem, riderIndex) => {
            if (riderItem !== undefined) {
              if (riderAmounts.get(riderIndex) !== null) {
                const riders = {} as Rider;

                riders.code = riderItem;
                riders.units = Number(riderAmounts.get(riderIndex));

                ridersList.push(riders);
              }
            }
          });
          policy.riders = ridersList;
        }
      }
      //GLTERM product riders configuration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.GLTerm]) {
        isReplacementPolicy = matchGLTERMByType({
          Group: groupApp => groupApp.replacement,
          _: () => false,
        })(application.glterm);
        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          isReplacementPolicy = application.premium.replacement;
          policy.planCode = application.planCodes.productType.value;
          policy.baseUnits = 0;
          policy.forcedPremium = ordinaryProductForcedPremiumValue(application.premium);
          policy.policyUnits = 0;
          policy.issueType = application.planCodes.issueType.value;
          policy.faceAmount = Number(application.planCodes.faceAmount.value);
          totalOfPremium = Number(application.premium.annually.value);
          policy.perDeduction = totalOfPremium;
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;
          policy.coverageLevel = application.planCodes.coverageLevel.value;
          policy.replacementPremium = application.premium.replacementPremium;
          policy.eeiIndicator = application.premium?.eeiIndicator;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          policy.riders = getRidersInQuality(application.planCodes.planCodes, policy.faceAmount);
        } else {
          totalOfPremium = totalOfPremium + Number(application.glterm.calculatedPremium.value);

          policy.planCode = 'GLTERM';
          policy.baseUnits = 0;
          policy.forcedPremium = Number(application.glterm.premium.value);
          policy.policyUnits = 0;
          policy.section125 = false;
          policy.faceAmount = Number(application.glterm.faceAmt.value);
          policy.perDeduction = Number(application.glterm.calculatedPremium.value);
          policy.monthlyBenefit = 0;
          policy.monthlySalary = 0;
          policy.coverageLevel = 'IND';
          policy.eeiIndicator = application.premium?.eeiIndicator;

          let {billingCode} = application.caseDetails as ValidGroupCaseDetails;

          let numberOfPays = 0;

          if (application.billingAgent.billingMode.value === '') {
            numberOfPays = application.billingModes.billingModes
              .flatMap(m => m.occurrences)
              .find(x => x.name.toUpperCase() === billingCode?.value.toUpperCase())?.frequency!;
          } else {
            numberOfPays = application.billingModes.billingModes
              .flatMap(m => m.occurrences)
              .find(x => x.name.toUpperCase() === application.billingAgent.billingMode.value.toUpperCase())?.frequency!;
          }

          const replacementPremium = (Number(application.glterm.premium.value) * numberOfPays) / 1.5;

          if (application.glterm.commission.value === 'First Year Commissions') {
            policy.replacementPremium = replacementPremium - 1;
          } else if (application.glterm.commission.value === 'Renewal Commissions') {
            policy.replacementPremium = replacementPremium + 1;
          }
          policy.issueType = application.glterm.plan.value;
          switch (policy.issueType) {
            case 'GLTERM':
              policy.issueType = 'SI';
              break;
            case 'SGLTERM':
              policy.issueType = 'CGI';
              break;
            case 'GIGLTERM':
              policy.issueType = 'GI';
              break;
          }
          policy.cashWithApplication = {
            amount: Number(application.glterm.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          const ridersList: Rider[] = [];

          const riderCodes = matchGLTERMByType({
            Ordinary: ordinaryApp => ordinaryApp.riderCodes,
            Group: groupApp => groupApp.riderInformation.codes,
            NewYork: newYorkApp => newYorkApp.riderCodes,
          })(application.glterm);

          const riderAmounts = matchGLTERMByType({
            Ordinary: ordinaryApp => ordinaryApp.riderAmounts,
            Group: groupApp => groupApp.riderInformation.amounts,
            NewYork: newYorkApp => newYorkApp.riderAmounts,
          })(application.glterm);
          riderCodes.forEach((riderItem, riderIndex) => {
            if (riderAmounts.get(riderIndex) !== null) {
              if (riderItem !== undefined && riderItem !== '') {
                const riders = {} as Rider;
                if (riderItem === 'CTPFPO') {
                  riders.code = 'GTLCFPO';
                } else if (riderItem === 'CTPCTR' || riderItem === 'CTPCTZ') {
                  riders.code = 'GTLCCTR';
                } else if (riderItem === 'CTPLBR') {
                  riders.code = 'GTLCLBR';
                } else if (riderItem === 'ADB') {
                  riders.code = 'GTLCADB';
                } else {
                  riders.code = riderCodes.get(riderIndex)!;
                }
                riders.units = Number(riderAmounts.get(riderIndex));

                if (!(riders.code === 'GTLCADB' && riders.units === 0)) {
                  ridersList.push(riders);
                }
              }
            }
          });
          policy.riders = ridersList;
        }
      } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.CriticalIllnessNY]) {
        totalOfPremium = totalOfPremium + Number(application.criticalIllnessNY.calculatedPremium.value);

        policy.planCode = 'GVCIP2NY';
        policy.baseUnits = 0;
        policy.forcedPremium = Number(application.criticalIllnessNY.premium.value);
        policy.policyUnits = 0;
        policy.perDeduction = Number(application.criticalIllnessNY.calculatedPremium.value);
        policy.section125 = application.criticalIllnessNY.section125;
        policy.monthlyBenefit = application.criticalIllnessNY.benefitAmount;
        policy.monthlySalary = 0;
        policy.coverageLevel = application.criticalIllnessNY.planType.value;
        policy.cashWithApplication = {
          amount: Number(application.criticalIllnessNY.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };
      }
      //Pincare products riders comfiguration
      else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.PinCare]) {
        totalOfPremium = totalOfPremium + Number(application.pinCare.calculatedPremium.value);

        policy.planCode = 'PINCARE';
        policy.baseUnits = Number(application.pinCare.units.value);
        policy.forcedPremium = Number(application.pinCare.premium.value);
        policy.policyUnits = 0;
        policy.section125 = false;
        policy.perDeduction = Number(application.pinCare.calculatedPremium.value);
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.coverageLevel = application.pinCare.planType.value;
        policy.cashWithApplication = {
          amount: Number(application.pinCare.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };
      } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.AccidentNewYork]) {
        const accidentNewYork = application.accidentNewYork as GroupAccidentNewYork;

        totalOfPremium = totalOfPremium + Number(accidentNewYork.calculatedPremium.value);

        policy.planCode = 'GVAP1NY';
        policy.baseUnits = Number(accidentNewYork.baseUnits.value);
        policy.forcedPremium = Number(accidentNewYork.premium.value);
        policy.policyUnits = 0;
        policy.perDeduction = Number(accidentNewYork.calculatedPremium.value);
        policy.section125 = (application.accidentNewYork as GroupAccidentNewYork).section125;
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.coverageLevel = accidentNewYork.planType.value;
        policy.cashWithApplication = {
          amount: Number(accidentNewYork.cwa.value),
          calculatedAmount: 0,
          transactionDate: new Date().toISOString().slice(0, 10),
        };
      } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Aip]) {
        if (mode === ApplicationModeType.Quality && !application.planCodes.replaceProduct) {
          policy.baseUnits = Number(application.planCodes.planCodes[0].units);
          policy.coverageLevel =
            operationType === OperationType.Validate && application.planCodes.coverageLevel.value === 'FAMILY'
              ? 'FAM'
              : application.planCodes.coverageLevel.value;
          policy.planOption = application.planCodes.packageOption.value;
          policy.section125 = application.premium.section125;
          policy.cashWithApplication = {
            amount: Number(application.premium.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          totalOfPremium = Number(application.premium.annually.value);

          policy.forcedPremium = groupProductForcedPremiumValue(application.premium);

          policy.perDeduction = totalOfPremium;
        } else {
          policy.baseUnits = Number(application.aip.units.value);
          policy.section125 = application.aip.section125;
          policy.cashWithApplication = {
            amount: Number(application.aip.cwa.value),
            calculatedAmount: 0,
            transactionDate: new Date().toISOString().slice(0, 10),
          };

          if (operationType === OperationType.Validate && application.aip.planType.value === 'FAMILY') {
            policy.coverageLevel = 'FAM';
          } else {
            policy.coverageLevel = application.aip.planType.value;
          }
          policy.planOption = application.aip.packageOption.value;
          totalOfPremium = Number(application.aip.calculatedPremium.value);

          policy.forcedPremium = Number(application.aip.premium.value);
          policy.perDeduction = totalOfPremium;
        }

        policy.planCode = 'AIP';
        policy.policyUnits = 0;
        policy.monthlyBenefit = 0;
        policy.monthlySalary = 0;
        policy.issueType = 'SI';
        defaultPhone = '0';
        defaultEmail = 'email@infoarmor.com';
      }

      policyLists.push(policy);
    });
  }

  const groupBillingAgentState = matchApplicationByType<string>({
    Group: groupApp =>
      matchBillingAgentByType({
        Group: g => g.state.value,
        _: () => '',
      })(groupApp.billingAgent),
    _: () => '',
  })(application);

  const applicationDetails: Application = {
    caseInformation: {
      caseName,
      caseNumber: caseNum?.toUpperCase(),
      numberOfPays: numberOfPays,
      dateOfFirstDeduction: application.billingAgent.issueDate
        ? DateUtility.toIsoDate(application.billingAgent.issueDate)
        : '',
      agents: agentsList,
      clients: clientListObject,
      dateSigned: application.billingAgent.dateSigned ? DateUtility.toIsoDate(application.billingAgent.dateSigned) : '',
      payorNumber:
        application.billingAgent.pac || application.billingAgent.directBill
          ? application.applicantDemographics.socialSecurityNumber.value
          : application.billingAgent.controlNumber.value,
      piIsPayor: isPrimaryInsuredthePayor(application),
      policies: policyLists,
      totalPremium: totalOfPremium,
      processCase: false,
      recordType: '',
      replacement: isReplacementPolicy,
      requestedIssueDate: application.billingAgent.issueDate
        ? DateUtility.toIsoDate(application.billingAgent.issueDate)
        : '',
      situs: matchApplicantDemographicsByType<string>({
        Group: groupApplicantDemographics =>
          groupBillingAgentState !== groupApplicantDemographics.state.value
            ? groupBillingAgentState || situsState.value
            : groupApplicantDemographics.state.value,
        NewYork: () => '',
        Ordinary: ordinaryApplicantDemographics => ordinaryApplicantDemographics.state.value,
        _: () => '',
      })(application.applicantDemographics),
      payroll: application.billingAgent.payroll,
      directBill: application.billingAgent.directBill,
      billingInkAuthorization: application.billingAgent.ink,
      billingTransitNumber: transitNumber === null ? '' : transitNumber,
      billingAccountNumber: accountNumber === null ? '' : accountNumber,
      billingDraftDay: draftDay === null ? '' : draftDay,
      billingMode: application.billingAgent.billingMode.value || billingCode?.value,
      floridaLicenseIncluded: matchBillingAgentByType({
        Ordinary: ordinaryBillingAgent => ordinaryBillingAgent.floridaLicense,
        _: () => false,
      })(application.billingAgent),
      achIndicator: application.caseDetails.achIndicator,
      achTransitNumber: application.billingAgent.achTransitNumber.value,
      achAccountNumber: application.billingAgent.achAccountNumber.value,
      achAccountType: application.billingAgent.achAccountType.value,
      achPayerName: application.billingAgent.achPayerName.value,
      achAuthorizationDate: application.billingAgent.achAuthorizationDate ? DateUtility.toIsoDate(application.billingAgent.achAuthorizationDate) : '',
      achDraftDay: application.billingAgent.achDraftDay.value,
      pac: application.billingAgent.pac,
    },
  };

  return applicationDetails;
};

function* updateToLife70Saga() {
  yield takeEvery(M.MessagesActionType.UPDATE, function*(action: ReturnType<typeof M.updateApplication>) {
    yield put(A.resetApplicationProductsAndRidersSection());

    const {application: applicationState, awdWorkKeyId} = action.payload;

    const applicationWizardModel = getApplicationDetails(applicationState, OperationType.Update);

    const caseNumber = applicationWizardModel.caseInformation.caseNumber;
    const proposedInsuredClients = applicationWizardModel.caseInformation.clients.filter(
      client => client.proposedInsured
    );

    let client;
    let fullSsn = '';
    let productGroup = '';

    if (proposedInsuredClients.length > 0) {
      client = proposedInsuredClients[0];

      fullSsn = client.ssn;
    }

    const applicationName = matchApplicationByType({
      Group: () => ApplicationType.Group,
      Ordinary: () => ApplicationType.Ordinary,
      NewYork: () => ApplicationType.NewYork,
      _: () => ApplicationType.Undefined,
    })(applicationState.application);

    const takeovers = [];

    for (let i = 0; i < applicationWizardModel.caseInformation.policies.length; i++) {
      const policy = applicationWizardModel.caseInformation.policies[i];

      productGroup = policy.productGroup;

      if (policy.productGroup.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Disability]) {
        if (applicationName === ApplicationType.Group) {
          productGroup = 'GrpDisability';
        } else if (applicationName === ApplicationType.Ordinary) {
          productGroup = 'OrdDisability';
        }
      }

      let takeoverResponse: AsyncResult<{caseTakeover: {active: boolean; takeoverSsnId: string}}> = yield getTakeover(
        caseNumber,
        productGroup,
        fullSsn
      );

      policy.takeover = false;

      if (E.isRight(takeoverResponse)) {
        const {active, takeoverSsnId} = takeoverResponse.right.caseTakeover;

        if (active) {
          policy.takeover = active;

          takeovers.push({productGroup: policy.productGroup, takeoverSsnId: takeoverSsnId});
        }
      }
    }

    const response: any = yield updateApplicationToLife70(applicationWizardModel);

    if (response.status === 200 || response.status === 201 || response.status === 400) {
      const {application} = applicationState;

      const signatureState = matchBillingAgentByType({
        Ordinary: ordinaryApp => ordinaryApp.signatureState.value,
        Group: groupApp => groupApp.state.value,
        _: () => '',
      })(application.billingAgent);

      const agent = applicationWizardModel.caseInformation?.agents?.find(x => x.agentSigned)?.ahlAgentCode;

      const firstName =
        client?.middleName === undefined
          ? client?.firstName!
          : client?.firstName! + ' ' + client?.middleName!.substring(0, 1);
      const lastName = client?.lastName!;
      const ssn = client?.ssn!;
      const payorNumber = applicationWizardModel.caseInformation.payorNumber;

      yield put(PR.changeFirstName(firstName));
      yield put(PR.changeLastName(lastName));
      yield put(PR.changeSocialSecurityNumber(ssn));
      yield put(PR.changeAgent(agent!));
      yield put(PR.changeCaseNumber(caseNumber));
      yield put(PR.changeStateSigned(signatureState));
      yield put(PR.changePayorNumber(payorNumber));

      const lockWorkItemKey: AsyncResult<LockWorkItemModel> = yield lockWorkItem(awdWorkKeyId);

      if (E.isRight(lockWorkItemKey)) {
        if (lockWorkItemKey.right.workInstance.lockedTo !== '') {
          const policyRecordDetails: PolicyRecordModel = {
            awdKeyId: awdWorkKeyId,
            fieldValues: [
              {
                name: WorkInstanceFieldValue.PayorNumber,
                value: payorNumber,
              },
              {
                name: WorkInstanceFieldValue.Agent,
                value: agent,
              },
              {
                name: WorkInstanceFieldValue.Ssn,
                value: ssn,
              },
              {
                name: WorkInstanceFieldValue.CaseNumber,
                value: caseNumber,
              },
              {
                name: WorkInstanceFieldValue.FirstName,
                value: firstName,
              },
              {
                name: WorkInstanceFieldValue.LastName,
                value: lastName,
              },
              {
                name: WorkInstanceFieldValue.StateSigned,
                value: signatureState,
              },
            ],
          } as any;

          const policyNumberUpdateResponse: AsyncResult<any> = yield updatePolicyRecord(policyRecordDetails);

          if (E.isRight(policyNumberUpdateResponse)) {
            if (policyNumberUpdateResponse.right === '') {
              const lockWorkItemKey: AsyncResult<LockWorkItemModel> = yield lockWorkItem(awdWorkKeyId);

              if (E.isLeft(lockWorkItemKey) && lockWorkItemKey.left.key === 'Unauthorized') {
                yield put(push(ApplicationEntryRouteConstants.AWDLogin));
              }
            }
          } else if (policyNumberUpdateResponse.left.key === 'Unauthorized') {
            yield put(push(ApplicationEntryRouteConstants.AWDLogin));
          }
        }
      } else if (lockWorkItemKey.left.key === 'Unauthorized') {
        yield put(push(ApplicationEntryRouteConstants.AWDLogin));
      }

      let annotated = false;
      let commentResponse: any;
      let snackbarMessage: string;

      for (let i = 0; i < applicationWizardModel.caseInformation.policies.length; i++) {
        const policy = applicationWizardModel.caseInformation.policies[i];

        if (policy.takeover) {
          commentResponse = yield addComment(
            'AE System Generated - Takeover Credit Approved.. waive pre-ex, INCLUDING #150 ENDORSEMENT',
            awdWorkKeyId
          );

          if (E.isRight(commentResponse)) {
            annotated = true;

            const takeover = takeovers.find(x => x.productGroup.toUpperCase() === policy.productGroup.toUpperCase());

            const updateAwdTakeoverResponse: AsyncResult<any> = yield updateTakeover(
              takeover!.takeoverSsnId,
              false,
              true
            );

            if (E.isRight(updateAwdTakeoverResponse)) {
            }

            const updateLife70TakeoverResponse: AsyncResult<any> = yield updateTakeover(
              takeover!.takeoverSsnId,
              true,
              false
            );

            if (E.isRight(updateLife70TakeoverResponse)) {
            }
          }
        }
      }

      snackbarMessage = '';

      if (annotated) {
        snackbarMessage = 'The AWD work item for this enrollment was annotated.';

        yield put(createSnackbar(snackbarMessage));
      }

      yield put(M.changeLife70ErrorMessage(new Loaded(response.data.messages)));
    } else if (response.status === 401 || response.status === 403) {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    }
  });
}

type WorkSelected = {
  summary: string;
  date: string;
  id: string;
  time: string;
};

type PolicyRecordModel = {
  awdKeyId: string;
  priorityIncrease: number;
  fieldValues: {
    name: string;
    value: string;
  }[];
};

type LockWorkItemModel = {
  message: string;
  workInstance: {
    lockedTo: string;
    id: string;
    businessAreaNameContent: string;
    typeNameContent: string;
    statusNameContent: string;
  };
};

type WorkInstance = {
  id: string;
  businessAreaNameContent: string;
  typeNameContent: string;
  statusNameContent: string;
  queueNameContent: string;
  assignedTo: string;
  userId: string;
  lockedTo: string;
  priorityIncrease: number;
  fieldValues: {
    name: string;
    value: string;
  }[];
};

type sourceInstance = {
  id: string;
};

function* awdSaveSaga() {
  yield takeEvery(M.MessagesActionType.AWD_SAVE, function*(action: ReturnType<typeof M.saveApplication>) {
    yield put(A.resetApplicationProductsAndRidersSection());

    const {application: applicationState, workQueueItems} = action.payload;
    const {application, mode} = applicationState;
    const work: UpdateWork = updateWork;

    const awdWorkKeyId = workQueueItems[0].awdworkkeyid;

    const validationMessages: object[] =
      application.messages.aueErrorMessage.key === 'Loaded' ? application.messages.aueErrorMessage.Data : [];
    const life70Messages: object[] =
      application.messages.life70ErrorMessage.key === 'Loaded' ? application.messages.life70ErrorMessage.Data : [];

    let annotated = false;
    let commentResponse: any;

    if (validationMessages.length > 0) {
      let aueMessageArr: object[] = [];
      validationMessages.map((message, index) => {
        let messageClassification = message['classifications'];
        let messageAUE = message['message'];
        let policyNumber = messageClassification['policy_number'] + messageClassification['product_code'];
        let workItemawd = workQueueItems?.find(workItem => workItem.policyNumber === policyNumber);
        let awdWorkKeyId = workItemawd?.awdworkkeyid;
        aueMessageArr.push({policyNumber, messageAUE, awdWorkKeyId});
      });
      // grouping the AUE messages as per awd id
      const groupValidationMsgAUE: object = groupBy(aueMessageArr, 'awdWorkKeyId');

      let result = Object.entries(groupValidationMsgAUE).map(([key, values]) => {
        const merged = values.reduce(
          (accum: {messageAUE: any}, x: {messageAUE: any}) => {
            accum.messageAUE += x.messageAUE;
            return accum;
          },
          {messageAUE: 0}
        );
        return [key, merged];
      });

      let resObj: object = fromEntries(result);
      for (var awdIdKey in resObj) {
        for (var messageAUEKey in resObj[awdIdKey]) {
          commentResponse = yield addComment(JSON.stringify(resObj[awdIdKey][messageAUEKey]), awdIdKey);
        }
      }

      if (E.isRight(commentResponse)) {
        annotated = true;
      }
    }

    if (life70Messages.length > 0) {
      let l70MessageArr: object[] = [];
      life70Messages.map((message, index) => {
        let messageClassification = message['classifications'];
        let messageL70 = message['message'];
        let policyNumber = messageClassification['policy_number'] + messageClassification['product_code'];
        let workItemawd = workQueueItems?.find(workItem => workItem.policyNumber === policyNumber);
        let awdWorkKeyId = workItemawd?.awdworkkeyid;
        if (awdWorkKeyId == undefined) {
          if (workQueueItems?.length == 1) {
            awdWorkKeyId = workQueueItems[0].awdworkkeyid;
          }
        }

        l70MessageArr.push({policyNumber, messageL70, awdWorkKeyId});
      });
      // grouping the l70 messages as per awd id
      const groupL70Message: object = groupBy(l70MessageArr, 'awdWorkKeyId');

      let result = Object.entries(groupL70Message).map(([key, values]) => {
        const merged = values.reduce(
          (accum: {messageL70: any}, x: {messageL70: any}) => {
            accum.messageL70 += x.messageL70;

            return accum;
          },
          {messageL70: 0}
        );
        return [key, merged];
      });

      let resObj: object = fromEntries(result);
      for (var awdIdKey in resObj) {
        for (var messageL70Key in resObj[awdIdKey]) {
          commentResponse = yield addComment(JSON.stringify(resObj[awdIdKey][messageL70Key]), awdIdKey);
        }
      }

      if (E.isRight(commentResponse)) {
        annotated = true;
      }
    }
    const form =
      application.billingAgent.formNumber.key === 'UserAssignedFormNumber'
        ? {
            documentShortName: application.billingAgent.formNumber.documentShortName,
            fipscoDocumentName: application.billingAgent.formNumber.fipscoDocumentName,
            value: application.billingAgent.formNumber.value,
          }
        : ({} as Form);

    var questStr = '';
    var quesData = '';
    const questions =
      application.uwQuestions.questionList.key === 'Loaded' ? application.uwQuestions.questionList.Data : '';

    if (questions !== '') {
      questions.forEach((questionnaire, index) => {
        var ques = questionnaire.questionName;
        var ans = application.uwQuestions.answers.get(index) as boolean;
        var finalAns = ans === true ? 'Y' : ans === false ? 'N' : 'X';
        questStr += ques + ':' + finalAns + ' ';
        quesData = `QuestionData : <${form?.documentLongName}> : ${questStr}`;
      });
    }
    if (quesData.length > 0) {
      for (let i = 0; i < workQueueItems.length; i++) {
        let awdWorkKeyIds = workQueueItems[i].awdworkkeyid;
        commentResponse = yield addComment(quesData, awdWorkKeyIds);
      }

      if (E.isRight(commentResponse)) {
        annotated = true;
      }
    }
    for (let rowIndex = 0; rowIndex < workQueueItems.length; rowIndex++) {
      work.awdKeyId = workQueueItems[rowIndex].awdworkkeyid;
      work.comment = application.awdStatus.comments.value;
      work.businessAreaName = application.policyRecord.businessArea.value;
      work.typeName = application.awdStatus.workType.value;
      work.statusName = application.awdStatus.status.value;
      if (work.statusName === 'PASSED') {
        sessionStorage.setItem('awdworkkeyid' + rowIndex, workQueueItems[rowIndex].awdworkkeyid);
        sessionStorage.setItem('businessAreaNameContent' + rowIndex, application.policyRecord.businessArea.value);
        sessionStorage.setItem('typeNameContent' + rowIndex, work.typeName);
        sessionStorage.setItem('statusNameContent' + rowIndex, work.statusName);
      }
      work.fieldValues[0].value = application.awdStatus.underwriter.value;

      if (rowIndex == 1) {
        work.typeName = application.awdStatus.workType2.value;
        work.statusName = application.awdStatus.status2.value;
        work.comment = application.awdStatus.comments2.value;
        work.fieldValues[0].value = application.awdStatus.underwriter2.value;
        if (work.statusName === 'PASSED') {
          sessionStorage.setItem('awdworkkeyid' + rowIndex, workQueueItems[rowIndex].awdworkkeyid);
          sessionStorage.setItem('businessAreaNameContent' + rowIndex, application.policyRecord.businessArea.value);
          sessionStorage.setItem('typeNameContent' + rowIndex, work.typeName);
          sessionStorage.setItem('statusNameContent' + rowIndex, work.statusName);
        }
      }
      if (rowIndex == 2) {
        work.typeName = application.awdStatus.workType3.value;
        work.statusName = application.awdStatus.status3.value;
        work.comment = application.awdStatus.comments3.value;
        work.fieldValues[0].value = application.awdStatus.underwriter3.value;
        if (work.statusName === 'PASSED') {
          sessionStorage.setItem('awdworkkeyid' + rowIndex, workQueueItems[rowIndex].awdworkkeyid);
          sessionStorage.setItem('businessAreaNameContent' + rowIndex, application.policyRecord.businessArea.value);
          sessionStorage.setItem('typeNameContent' + rowIndex, work.typeName);
          sessionStorage.setItem('statusNameContent' + rowIndex, work.statusName);
        }
      }

      const lockResponse: AsyncResult<LockWorkItemModel> = yield lockWorkItem(work.awdKeyId);

      if (E.isRight(lockResponse)) {
        const status: number = yield updateWorkItem(work);
        if (status === 204 || status === 200 || status === 201) {
          const awdworkkeyid = sessionStorage.setItem('awdworkkeyid', lockResponse.right.workInstance.id);

          const businessAreaNameContent = sessionStorage.setItem(
            'businessAreaNameContent',
            lockResponse.right.workInstance.businessAreaNameContent
          );
          const typeNameContent = sessionStorage.setItem(
            'typeNameContent',
            lockResponse.right.workInstance.typeNameContent
          );
          const statusNameContent = sessionStorage.setItem('statusNameContent', application.awdStatus.status.value);
          if (mode === ApplicationModeType.Quality) {
            yield all([
              put(createSnackbar('AWD Save Successful')),
              put(push((window.location.href = ApplicationEntryRouteConstants.WorkQueue))),
            ]);
          }
          yield all([put(createSnackbar('AWD Save Successful')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
        } else {
          if (mode === ApplicationModeType.Quality) {
            yield all([
              put(createSnackbar('AWD Save Failed')),
              put(push((window.location.href = ApplicationEntryRouteConstants.WorkQueue))),
            ]);
          }
          yield all([put(createSnackbar('AWD Save Failed')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
        }
      } else if (lockResponse.left.key === 'Unauthorized') {
        yield all([put(createSnackbar('AWD Save Failed')), put(push(ApplicationEntryRouteConstants.AWDLogin))]);
      } else {
        yield all([put(createSnackbar('AWD Save Failed')), put(push(ApplicationEntryRouteConstants.WorkQueue))]);
      }
    }
  });
}

function* saveToLife70Saga() {
  yield takeEvery(M.MessagesActionType.SAVE, function*(action: ReturnType<typeof M.saveApplication>) {
    yield put(A.resetApplicationProductsAndRidersSection());

    const {application: applicationState, workQueueItems} = action.payload;
    const awdWorkKeyId = workQueueItems[0].awdworkkeyid;
    let typeNameContent = '';
    let businessAreaNameContent = '';
    let queueNameContent = '';
    let userId = '';
    let statusNameContent = '';

    const applicationWizardModel = getApplicationDetails(applicationState, OperationType.Save);

    const caseNumber = applicationWizardModel.caseInformation.caseNumber;
    const proposedInsuredClients = applicationWizardModel.caseInformation.clients.filter(
      client => client.proposedInsured
    );

    let client;
    let fullSsn = '';
    let productGroup = '';

    if (proposedInsuredClients.length > 0) {
      client = proposedInsuredClients[0];

      fullSsn = client.ssn;
    }

    const applicationName = matchApplicationByType({
      Group: () => ApplicationType.Group,
      Ordinary: () => ApplicationType.Ordinary,
      NewYork: () => ApplicationType.NewYork,
      _: () => ApplicationType.Undefined,
    })(applicationState.application);

    const takeovers = [];

    for (let i = 0; i < applicationWizardModel.caseInformation.policies.length; i++) {
      const policy = applicationWizardModel.caseInformation.policies[i];

      productGroup = policy.productGroup;

      if (policy.productGroup.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Disability]) {
        if (applicationName === ApplicationType.Group) {
          productGroup = 'GrpDisability';
        } else if (applicationName === ApplicationType.Ordinary) {
          productGroup = 'OrdDisability';
        }
      }

      let takeoverResponse: AsyncResult<{caseTakeover: {active: boolean; takeoverSsnId: string}}> = yield getTakeover(
        caseNumber,
        productGroup,
        fullSsn
      );

      policy.takeover = false;

      if (E.isRight(takeoverResponse)) {
        const {active, takeoverSsnId} = takeoverResponse.right.caseTakeover;

        if (active) {
          policy.takeover = active;

          takeovers.push({productGroup: policy.productGroup, takeoverSsnId: takeoverSsnId});
        }
      }
    }

    const response: any = yield saveApplicationToLife70(applicationWizardModel);
    const {application} = applicationState;

    const signatureState = matchBillingAgentByType({
      Ordinary: ordinaryApp => ordinaryApp.signatureState.value,
      Group: groupApp => groupApp.state.value,
      _: () => '',
    })(application.billingAgent);
    const agent = applicationWizardModel.caseInformation?.agents?.find(x => x.agentSigned)!?.ahlAgentCode;

    const firstName =
      client?.middleName === undefined
        ? client?.firstName!
        : client?.firstName! + ' ' + client?.middleName!.substring(0, 1);
    const lastName = client?.lastName!;
    const ssn = client?.ssn!;
    const payorNumber = applicationWizardModel.caseInformation.payorNumber;

    yield put(PR.changeFirstName(firstName));
    yield put(PR.changeLastName(lastName));
    yield put(PR.changeSocialSecurityNumber(ssn));
    yield put(PR.changeAgent(agent));
    yield put(PR.changeCaseNumber(caseNumber));
    yield put(PR.changeStateSigned(signatureState));
    yield put(PR.changePayorNumber(payorNumber));

    if (response.status === 200 || response.status === 400 || response.status === 201 || response.status === 204) {
      let policyNumberUpdated = false;
      if (workQueueItems[0].policyNumber === undefined) {
        workQueueItems[0].policyNumber =
          applicationWizardModel.caseInformation.policies[0].policyNumber +
          applicationWizardModel.caseInformation.policies[0].productCode;
      }
      const companyCode = applicationWizardModel.caseInformation.policies[0].companyCode!;
      yield put(PR.changeAsyncPolicyNumber(new Loaded(workQueueItems[0].policyNumber)));
      const workItemChildrenResponse: AsyncResult<{
        awdWorkKeyId: string;
        id: string;
        sourceInstances: sourceInstance[];
      }> = yield getWorkItemChildren(awdWorkKeyId);

      let assignedWorkItemResponse: AsyncResult<{
        work: any;
        messages: {message: string; responseSeverity: string}[];
      }> = yield getAssignedWorkItem();

      if (E.isRight(assignedWorkItemResponse)) {
        if (
          assignedWorkItemResponse.right.work.id !== undefined &&
          assignedWorkItemResponse.right.work.id !== null &&
          assignedWorkItemResponse.right.work.id !== ''
        ) {
          userId = assignedWorkItemResponse.right.work?.assignedToHref;
          let userIdArr = userId.split('/');
          userId = userIdArr[userIdArr.length - 1];
          queueNameContent = assignedWorkItemResponse.right.work?.queueNameContent;
          typeNameContent = assignedWorkItemResponse.right.work?.typeNameContent;
          businessAreaNameContent = assignedWorkItemResponse.right.work?.businessAreaNameContent;
          statusNameContent = assignedWorkItemResponse.right.work?.statusNameContent;
        }
      }
      if (
        application.caseDetails.productType.key === 'LoadedPolicyTypes' &&
        application.caseDetails.productType.selectedPolicyTypes.length > 1
      ) {
        if (userId == '' && queueNameContent == '' && typeNameContent == '' && businessAreaNameContent == '') {
          let getWorkItemResponse: AsyncResult<{
            work: any;
            messages: {message: string; responseSeverity: string}[];
          }> = yield getWorkItem();

          if (E.isRight(getWorkItemResponse)) {
            if (
              getWorkItemResponse.right.work.id !== undefined &&
              getWorkItemResponse.right.work.id !== null &&
              getWorkItemResponse.right.work.id !== ''
            ) {
              userId = getWorkItemResponse.right.work?.assignedToHref;
              let userIdArr = userId.split('/');
              userId = userIdArr[userIdArr.length - 1];
              queueNameContent = getWorkItemResponse.right.work?.queueNameContent;
              typeNameContent = getWorkItemResponse.right.work?.typeNameContent;
              businessAreaNameContent = getWorkItemResponse.right.work?.businessAreaNameContent;
              statusNameContent = getWorkItemResponse.right.work?.statusNameContent;
            }
          }
        }
      }

      for (let i = 1; i < applicationWizardModel.caseInformation.policies.length; i++) {
        const policy = applicationWizardModel.caseInformation.policies[i];
        var policyNumber = policy.policyNumber + policy.productCode;

        const workItems: WorkInstance = {
          id: '1235',
          userId: userId,
          typeNameContent: typeNameContent,
          businessAreaNameContent: businessAreaNameContent,
          queueNameContent: queueNameContent,
          statusNameContent: statusNameContent,
          assignedTo: '',
          lockedTo: '',
          fieldValues: [
            {
              name: WorkInstanceFieldValue.PolicyNumber,
              value: policyNumber,
            },
            {
              name: WorkInstanceFieldValue.CoCode,
              value: companyCode.toString(),
            },
            {
              name: WorkInstanceFieldValue.PayorNumber,
              value: payorNumber,
            },
            {
              name: WorkInstanceFieldValue.Agent,
              value: agent,
            },
            {
              name: WorkInstanceFieldValue.Ssn,
              value: ssn,
            },
            {
              name: WorkInstanceFieldValue.CaseNumber,
              value: caseNumber,
            },
            {
              name: WorkInstanceFieldValue.FirstName,
              value: firstName,
            },
            {
              name: WorkInstanceFieldValue.LastName,
              value: lastName,
            },
            {
              name: WorkInstanceFieldValue.StateSigned,
              value: signatureState,
            },
          ],
          priorityIncrease: 0,
        };

        var workItem = workQueueItems.find(workItem => workItem.policyNumber === policyNumber);

        if (policyNumber !== undefined && workItem === undefined) {
          let createWork: AsyncResult<{
            awdKeyId: string;
          }> = yield createWorkItem(workItems);

          if (E.isRight(createWork)) {
            let workQueueItem: WorkQueueItem = {} as WorkQueueItem;
            workQueueItem.awdworkkeyid = createWork.right.awdKeyId;
            workQueueItem.policyNumber = policyNumber;
            yield put(addWorkItem(workQueueItem));

            policy.awdWorkId = createWork.right.awdKeyId;
          }

          if (E.isRight(workItemChildrenResponse)) {
            const sourceInstances = workItemChildrenResponse.right.sourceInstances;
            for (let i = 0; i < sourceInstances.length; i++) {
              let childrenRelationship: AsyncResult<{}> = yield createChildrenRelationship(
                policy.awdWorkId,
                sourceInstances[i].id
              );
            }
          }
        }
      }

      for (let i = 0; i < applicationWizardModel.caseInformation.policies.length; i++) {
        const policy = applicationWizardModel.caseInformation.policies[i];
        const policyNumber = policy.policyNumber + policy.productCode;
        const companyCode = policy.companyCode!;

        const agent = applicationWizardModel.caseInformation?.agents?.find(x => x.agentSigned)?.ahlAgentCode;

        const firstName =
          client?.middleName === undefined
            ? client?.firstName!
            : client?.firstName! + ' ' + client?.middleName!.substring(0, 1);
        const lastName = client?.lastName!;
        const ssn = client?.ssn!;
        const payorNumber = applicationWizardModel.caseInformation?.payorNumber;

        yield put(PR.changeFirstName(firstName));
        yield put(PR.changeLastName(lastName));
        yield put(PR.changeSocialSecurityNumber(ssn));
        yield put(PR.changeAgent(agent!));
        yield put(PR.changeCaseNumber(caseNumber));
        yield put(PR.changeStateSigned(signatureState));
        yield put(PR.changePayorNumber(payorNumber));
        yield put(PR.changeAsyncPolicyNumber(new Loaded(policyNumber)));

        yield put(PR.changePolicyNumber(policyNumber));
        yield put(PR.changeCoCode('' + companyCode));

        yield put(PR.changeAsyncPolicyNumber(new Loaded(policyNumber)));

        const currentWorkItem = workQueueItems.find(o => o.policyNumber === policyNumber);

        if (currentWorkItem !== undefined) {
          const policyRecordDetails: PolicyRecordModel = {
            awdKeyId: currentWorkItem.awdworkkeyid,
            fieldValues: [
              {
                name: WorkInstanceFieldValue.PolicyNumber,
                value: policyNumber,
              },
              {
                name: WorkInstanceFieldValue.CoCode,
                value: companyCode,
              },
              {
                name: WorkInstanceFieldValue.PayorNumber,
                value: payorNumber,
              },
              {
                name: WorkInstanceFieldValue.Agent,
                value: agent,
              },
              {
                name: WorkInstanceFieldValue.Ssn,
                value: ssn,
              },
              {
                name: WorkInstanceFieldValue.CaseNumber,
                value: caseNumber,
              },
              {
                name: WorkInstanceFieldValue.FirstName,
                value: firstName,
              },
              {
                name: WorkInstanceFieldValue.LastName,
                value: lastName,
              },
              {
                name: WorkInstanceFieldValue.StateSigned,
                value: signatureState,
              },
            ],
          } as any;

          const policyNumberUpdateResponse: AsyncResult<any> = yield updatePolicyRecord(policyRecordDetails);

          if (E.isRight(policyNumberUpdateResponse)) {
            if (policyNumberUpdateResponse.right === '') {
              policyNumberUpdated = true;

              const lockWorkItemKey: AsyncResult<LockWorkItemModel> = yield lockWorkItem(awdWorkKeyId);

              if (E.isLeft(lockWorkItemKey) && lockWorkItemKey.left.key === 'Unauthorized') {
                yield put(push(ApplicationEntryRouteConstants.AWDLogin));
              }
            }
          } else if (policyNumberUpdateResponse.left.key === 'Unauthorized') {
            yield put(push(ApplicationEntryRouteConstants.AWDLogin));
          }
        }
      }

      let annotated = false;
      let commentResponse: any;

      if (applicationName === 'GROUP') {
        //middle tier service call
        const grpDisability = application.disability as GroupDisability;
        const saldOccClass =
          grpDisability?.occClass.key == 'Loaded' ? grpDisability.occClass.Data.saldOccClassInfo.originalOccClass : '';

        const mentalNervousExclusion =
          grpDisability?.occClass.key == 'Loaded'
            ? grpDisability.occClass.Data.saldOccClassInfo.mentalNervousExclusion
            : '';

        const saldSitus = application.billingAgent?.state.value;

        const createSaldMiddleTierCall: AsyncResult<any> = yield getSaldOccClassInfo(
          saldOccClass,
          mentalNervousExclusion,
          saldSitus
        );

        if (E.isRight(createSaldMiddleTierCall)) {
        }

        const writeToApplicantStatusResponse: AsyncResult<{
          writeToApplicantStatus: {applicantStatus: string};
        }> = yield getWriteToApplicantStatus(caseNumber);

        let writeToApplicantComment = 'WRITE TO AGENT';

        if (
          E.isRight(writeToApplicantStatusResponse) &&
          writeToApplicantStatusResponse.right.writeToApplicantStatus.applicantStatus === '1'
        ) {
          writeToApplicantComment = 'WRITE TO APPLICANT';
        }

        commentResponse = yield addComment(writeToApplicantComment, awdWorkKeyId);

        if (E.isRight(commentResponse)) {
          annotated = true;
        }
      }

      for (let i = 0; i < applicationWizardModel.caseInformation.policies.length; i++) {
        const policy = applicationWizardModel.caseInformation.policies[i];

        if (policy.takeover) {
          commentResponse = yield addComment(
            'AE System Generated - Takeover Credit Approved.. waive pre-ex, INCLUDING #150 ENDORSEMENT',
            awdWorkKeyId
          );

          if (E.isRight(commentResponse)) {
            annotated = true;

            const takeover = takeovers.find(x => x.productGroup.toUpperCase() === policy.productGroup.toUpperCase());

            const createAwdTakeoverResponse: AsyncResult<any> = yield createTakeover(
              takeover!.takeoverSsnId,
              false,
              true
            );

            if (E.isRight(createAwdTakeoverResponse)) {
            }

            const createLife70TakeoverResponse: AsyncResult<any> = yield createTakeover(
              takeover!.takeoverSsnId,
              true,
              false
            );

            if (E.isRight(createLife70TakeoverResponse)) {
            }
          }
        }
      }

      let snackbarMessage;

      if (annotated) {
        snackbarMessage = 'The AWD work item for this enrollment was annotated';

        if (policyNumberUpdated) {
          snackbarMessage += ', and the policy number was updated.';
        } else {
          snackbarMessage += '.';
        }

        yield put(createSnackbar(snackbarMessage));
      } else if (policyNumberUpdated) {
        snackbarMessage = 'The policy number of the AWD work item for this enrollment was updated.';

        yield put(createSnackbar(snackbarMessage));
      }

      yield put(M.changeLife70ErrorMessage(new Loaded(response.data.messages)));
    } else if (response.status === 401 || response.status === 403) {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    }
  });
}

function* validateAgainstAUESaga() {
  yield takeEvery(M.MessagesActionType.VALIDATE_AUE, function*(action: ReturnType<typeof M.validateAUE>) {
    yield put(A.resetApplicationProductsAndRidersSection());
    const response: AsyncResult<AUEResponse> = yield validateAppAgainstAUE70(
      getApplicationDetails(action.payload.application, OperationType.Validate)
    );
    if (E.isRight(response)) {
      yield put(M.changeAUEMessage(new Loaded(response.right.messages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      const {left} = response;
      yield put(
        M.changeAUEMessage(
          new Loaded(left instanceof ServerError ? left.errorDetails.validations[0].validationMessages : {})
        )
      );
    }
  });
}

export default function*() {
  yield all([saveToLife70Saga(), updateToLife70Saga(), validateAgainstAUESaga(), awdSaveSaga()]);
}